import React, { useMemo, useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaeSelectBox from "../../../../common_components/common_widgets/select-box/component";
import MdaeTextBox from "../../../../common_components/common_widgets/text-box/component";
import { actions, callOperation } from "async-ops";
import { GET_CASE_DATA } from "./services/get-case-data";
import "./index.scss";
import { cloneDeep, first, isEqual } from "lodash";
import {
  Validator,
  RequiredRule,
  CustomRule,
} from "devextreme-react/validator";
import MdaeNumericBox from "../../../../common_components/common_widgets/numeric-box";
import MdaeCheckBox from "../../../../common_components/common_widgets/check-box";
import MdaeDateBox from "../../../../common_components/common_widgets/date-box";
import MdaeAccordion from "../../../../common_components/common_widgets/accordion";
import MdaeTextArea from "../../../../common_components/common_widgets/text-area";
import MdaeTabPanel from "../../../../common_components/common_widgets/tab-panel";
import { Item } from "devextreme-react/tab-panel";
import {
  caseDataValidationModes,
  defaultCaseDataWarningPopupData,
  RESET_CASE_FORM_DATA,
  SET_CASE_DATA_ACCORDION_SELECTED_KEYS,
  SET_CASE_DATA_VALIDATION_MODE,
  SET_CASE_FORM_DATA,
  SET_EXTERNAL_AUDIT_PROPERTIES,
  SET_RECORD_SUBMISSION_METHOD_DATA,
  UPDATE_ROUND_DATA,
  SET_CASE_PROPERTIES_DATA,
  SET_TARGET_TYPE_VALUE_DATA_SOURCE,
  SET_TARGET_TYPES_LOOKUP,
  SET_IS_SET_TARGET_CODE_VALUES,
  formatFetchedCaseData,
  SET_RISK_AMOUNT_ALERT_STATUS,
  OutcomeTypes,
  SET_ROUND_DATA_SELECTED_TAB,
} from "./reducers/case-data-reducer";
import { convertDate, convertDateFormat,compareDates } from "../../../../utils/dateUtils";
import MdaeDataGrid, {
  IMdaeDataGridProps,
} from "../../../../common_components/common_widgets/data-grid";
import {
  HIDE_LOADER,
  SHOW_LOADER,
  TOGGLE_CONFIRMATION_POPUP,
  TOGGLE_NOTIFY_POPUP,
} from "../../../../common_components/mdae-common-reducer";
import {
  FG_AUDIT_A_CASE,
  FG_EXTERNAL_USER_TASK_EDITING,
  getUserPermissionObject,
  hasAnyFeatureGroupAccess,
} from "../../../../common_components/user-permissions-helper";
import { toggleBillHistoryPopupVisible } from "../../case-list/bill-history";
import { QUICK_COMPLETE_USER_TASK } from "../../../../common_components/user-task-list/services/quick-complete-user-task";
import { AsignedToComponent, AuditorNotesComponent, CompletedByComponent, CompletedOnComponent, CompleteTaskCheckBoxComponent, DueDateComponent, getTaskItem, ManagerNotesComponent, onValueChanged, openUserTaskInEditMode, RescheduledDateComponent, ScheduledTimeComponent, SchedulingNotesComponent, TaskStatusComponent, TotalTimeComponent } from "../../../../common_components/user-task-list/add-user-task";
import { NOTIFY_POPUP_TYPES } from "../../../../common_components/common_widgets/notify-popup";
import mdaeNotify, {
  NOTIFY_MESSAGE_TYPE,
} from "../../../../common_components/common_widgets/toast/notify";
import Guid from "devextreme/core/guid";
import MdaeButton from "../../../../common_components/common_widgets/button";
import EACaseDataWarningPopup, {
  EA_CASE_DATA_WARNING_POPUP_MODES,
  toggleEaCaseDataWarningPopupVisible,
} from "./case-data-warning-popup";
import { GET_EA_REQUESTER_BY_ID } from "../../services/get-requester-by-id";
import { SET_IS_CURRENT_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR, SET_IS_PROCESS_TEMPLATE_VALID, SET_IS_REVIEW_CONTRACTOR_VALID_FOR_CURRENT_REQUESTER, SET_VALID_CURRENT_CONTENT_TYPE_LIST } from "../../reducers/external-audit-reducer";
import { EmailRule, PatternRule } from "devextreme-react/data-grid";
import { UPDATE_EXISTING_TASKS_DUE_DATE } from "./services/update-exising-tasks-due-date";
import { PROFESSIONAL, auditModes, qioReviewContractorCodes } from "../../constants";
import { toggleDenialReasonsPopup } from "../../../external-audit-setup/denial-reasons/component";
import AddDenialReasonsPopup from "../../../external-audit-setup/denial-reasons/denial-reason-pop-up";
import MdaeTagBox from "../../../../common_components/common_widgets/tag-box";
import { GET_EA_TARGET_VALUE_SOURCES } from "../../services/get-ea-target-value-sources";
import RiskAmountAlertPopup from "./risk-amount-alerts-popup";
import { invalidOrUnprintableCharMassage, isPrintableAscii } from "../../audit-properties-target-data-section";
import MdaeAutoComplete from "../../../../common_components/common_widgets/autocomplete";
import { GET_TARGET_RATIONALE_LOOKUP_DATA } from "../../services/get-target-rationale-lookup-data";
import { GET_TARGET_DATA_LOOKUPS } from "../../services/get-target-data-lookups";
import { SET_AUDIT_PROPERTIES_DATA, getAuditData, sortSelectedItemsOnTop } from "../../reducers/audit-properties-reducer";
import { GET_CODE_TYPES_LOOKUPS } from "../../services/get-code-types-lookups";
import { CASE_DETAIL_POPUP_MODES } from "../component";
import { GET_AUDIT_GROUPS } from "../../services/get-audit-groups";
import { GET_PROCESS_MANAGERS_LIST } from "../../services/get-process-managers-list";
import { GET_AUDIT_STATUS } from "../../services/get-audit-status";
import { AuditGroupComponent, CaseProcessManagerComponent, ProcessTemplateComponent, StartDateComponent } from "../../audit-properties-general-section";
import { useTargetValueDatasource } from '../../../../common_components/target-components';
import ValidationGroup from "devextreme-react/validation-group";
import { CASE_ADD_LOCATIONS } from "../../../../common_components/add-case-manual/constant";
import RoundLineLevelTrackingComponent from "./round-line-livel-charges-tracking";
import { GET_AUDIT_PROPERTIES_DATA_BY_DOCUMENT_ID } from "../../services/get-audit-properties-data-by-documentid";
import CollapsiblePanel from "../../../../common_components/common_widgets/collapsible-panel";
import { GET_TARGET_VALUE_LOOKUP } from "../../services/get-taregt-values";
import { GET_STATUS_LOOKUP_LIST } from "./services/get-audit-case-finding-status";
import { GET_OUTCOMES_LIST } from "../../../external-audit-setup/outcomes/services/get-outcomes-list";
import { SET_CASE_FINAL_OUTCOME_LIST_WITH_TERM_DATE } from "../../../external-audit-setup/outcomes/reducers/outcomes-reducers";
import Resizable from "../../../../common_components/common_widgets/resizable-panel";
import { bindActionCreators } from "redux";
import { USER_TASK_POPUP_MODE } from "../../../../common_components/user-task-list/component";
import { useTaskCommonFunctions } from "../../../../common_components/user-task-list/hooks/use-task-common-functions";
import EditDocumentPopup, { DOCUMENT_POPUP_MODE, toggleEditDocumentPopupVisible } from "../../../../common_components/document-management/edit-document-popup";
import { SET_USER_TASK_FORM_DATA } from "../../../../common_components/user-task-list/reducers/user-task-list-reducer";
import SelectExternalUser from "../../../../common_components/select-external-user";
import SelectAssignedGroupUser from "../../../../common_components/select-assigned-user";
import { GET_DOCUMENTS } from "../../../../common_components/document-management/services/get-documents";
import { GET_USER_TASK_LIST_BY_LEVEL } from "../../../../common_components/user-task-list/services/get-user-task-list-by-level";
export const caseDataValidationGroup = "CaseDataValidationGroup";
export const isTargetTypeOfCode = (caseTargetType) => {
  if (
    caseTargetType === "CPTHCPCS" ||
    caseTargetType === "ICDD" ||
    caseTargetType === "ICDP" ||
    caseTargetType === "DRG" ||
    caseTargetType === "APR_DRG" ||
    caseTargetType === "MODIFIER" ||
    caseTargetType === "PROVIDER" ||
    caseTargetType === "FACILITY" ||
    caseTargetType === "RENDERING_PROVIDER_GROUP"
  ) {
    return true;
  }
  return false;
};

export const isRoundLineLevelEnabled = (caseData) => {
  const isEnabled = Number(caseData?.isRoundLineLevelEnabledForAudit) === 1;
  const sequence = Number(caseData?.sequenceNo);
  if (!isEnabled || !sequence) return false;
  if (sequence === 1) return true;
  // For sequence > 1, check if roundData for sequence 1 has roundCharges
  const firstRound = Array.isArray(caseData?.roundData)
    ? caseData.roundData.find(r => Number(r.sequenceNo) === 1)
    : null;
  if (sequence > 1 && firstRound && Array.isArray(firstRound.roundCharges) && firstRound.roundCharges.length > 0) {
    return true;
  }
  return false;
}

//Format the financial fields to have only 2 decimal places and commas as thousand separator while displaying in the UI and also allow only numbers and decimal point as input.
const formatCurrency = (value) => {
  if (value == null || value === "") return "";
  let sanitized = value.toString().replace(/[^0-9.]/g, "");
  const parts = sanitized.split(".");
  if (parts.length > 2) {
    sanitized = parts[0] + "." + parts.slice(1).join("");
  }
  if (sanitized.includes(".")) {
    let [intPart, decPart] = sanitized.split(".");

    sanitized =
      intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
      "." +
      (decPart ? decPart.substring(0, 2) : "");
  } else {
    sanitized = sanitized.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return `$ ${sanitized}`;
};

const parseNumber = (value) => {
  if (!value) return 0;
  return value.toString().replace(/[^0-9.]/g, "");
};

// Normalize the input to allow only numbers and decimal point and restrict to 2 decimal places for financial fields
const normalizeCurrencyInput = (e) => {
  const inputElement = e.event.target as HTMLInputElement;
  let val = inputElement.value;
  let sanitized = val.replace(/[^0-9.]/g, "");
  const parts = sanitized.split(".");
  if (parts.length > 2) {
    sanitized = parts[0] + "." + parts.slice(1).join("");
  }
  if (sanitized.includes(".")) {
    let [intPart, decPart] = sanitized.split(".");

    sanitized =
      Number(intPart) + "." + (decPart ? decPart.substring(0, 2) : "");
  } else {
    sanitized = Number(sanitized).toString();
  }
  if (val !== sanitized) {
    e.component.option("value", sanitized);
  }
};

const checkStringHasAllNumbers = (stringToCheck: string) =>{
  return /^\d+$/.test(stringToCheck);
}

export const checkIsPermOrQioReviewContractor = (
  reviewContractorCode: string
) => {
  return (
    reviewContractorCode?.toLowerCase() === "perm" ||
    qioReviewContractorCodes.includes(reviewContractorCode?.toLowerCase())
  );
};

export const verifyPayerCaseId = (payerCaseId, reviewContractorCode) => {
  const isPermOrQioReviewContractor = checkIsPermOrQioReviewContractor(
    reviewContractorCode
  );
  if (!payerCaseId) return false;
  let isOnlyNumberString = checkStringHasAllNumbers(payerCaseId);
  if (isPermOrQioReviewContractor) {
    if (payerCaseId.length === 11) {
      return true;
    }
  } else {
    if (
      (isOnlyNumberString &&
        (payerCaseId.length == 8 ||
          (payerCaseId.length >= 13 && payerCaseId.length <= 15))) ||
      (/[\w,\s]+/.test(payerCaseId) &&
        payerCaseId.length >= 17 &&
        payerCaseId.length <= 23)
    ) {
      return true;
    }
  }
  return false;
};

export const getCaseDataTabDataById = (dispatch, eaCaseId) => {
  dispatch({ type: RESET_CASE_FORM_DATA });
  dispatch({ type: SHOW_LOADER });

  callOperation(GET_CASE_DATA, eaCaseId).then(function (response) {
    dispatch({
      type: SET_CASE_FORM_DATA,
      data: {
        caseData: {
          ...(formatFetchedCaseData(response.caseData)),
          previousCaseFinalOutcomeId: response?.caseData?.caseFinalOutcomeId,
        },
      },
    });
    dispatch({
      type: SET_RECORD_SUBMISSION_METHOD_DATA,
      data: {
        recordSubmissionMethodEnumDisplayList:response?.recordSubmissionMethodEnumDisplayList
      },
    });

    if (response.caseData?.roundData && response.caseData?.roundData.length) {
      dispatch({
        type: SET_CASE_DATA_ACCORDION_SELECTED_KEYS,
        data: {
          keys: response.caseData?.roundData,
        },
      });
    }

    dispatch({ type: HIDE_LOADER });
  });
};

interface ITaskAssociatedWithCaseDataGrid {
  currentEaRoundCaseId: number;
}
const TaskAssociatedWithCaseDataGrid: React.FC<ITaskAssociatedWithCaseDataGrid> = (
  props
) => {
  const caseData = useSelector(
    (state) => state["caseDataReducer"].caseData,
    isEqual
  );
  const userTaskList = useSelector(
    (state) => state["userTaskListReducer"].userTaskList,
    isEqual
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );

  const dispatch = useDispatch();
  let completedUserTaskIds = [];
  if (userTaskList && userTaskList.length) {
    completedUserTaskIds = userTaskList
      ?.filter((x) => x.statusType.toLowerCase() === "completed")
      ?.map((x) => x.userTaskId);
  }

  var currentRoundData = caseData?.roundData?.filter(
    (x) => x.eaRoundCaseId === props.currentEaRoundCaseId
  );
  let roundTasks = currentRoundData[0]?.roundTask?.filter(
    (x) =>
      x.statusType?.toLowerCase() !== "completed" &&
      completedUserTaskIds.filter((y) => y === x.userTaskId).length <= 0
  );
  roundTasks = roundTasks || [];

  const taskAssociatedCaseDataGridOptions = useMemo(
    () =>
      getTaskAssociatedCaseDataGridOptions(
        dispatch,
        roundTasks,
        currentUser,
        caseData,
        props.currentEaRoundCaseId
      ),
    [roundTasks]
  );

  return (
    <MdaeDataGrid
      id="grdTaskAssociatedCase"
      className={"top-margin"}
      {...taskAssociatedCaseDataGridOptions}
    />
  );
};

const PullTotalChargeAmountButton = ({ caseDetailData, dispatch, toggleBillHistoryPopupVisible,varToUpdate }) => {
  const handleClick = () => {
    const billData = {
      parent: caseDetailData,
      child: caseDetailData.caseBillingHistoryList[0],
    };

    toggleBillHistoryPopupVisible(dispatch, true, billData, true,varToUpdate);
  };

  return (
    <MdaeButton
      id="btnPullTotalChargeAmount"
      role="dxButton"
      stylingMode="text"
      className="no-right-margin pull-total-charge-amount"
      onClick={handleClick}
    >
      <span className="case-data-field1-dollar-icon">
        <i className="hand-hover dollar-green-icon"></i>
      </span>
    </MdaeButton>
  );
};


const onContentTypeClick = () => {
  window.open("/externalaudit/admin/contenttypes", "_blank");
};
interface ICasePropertiesTab {
  mdAuditCaseId: number;
}
const CasePropertiesTab: React.FC<ICasePropertiesTab> = (props) => {
  const isCurrentRequesterReviewContractorValid = useSelector(
    (state) =>
      state["externalAuditReducer"].isCurrentRequesterReviewContractorValid,
    isEqual
  );
  const isCurrentContentTypeInvalidForReviewContractor = useSelector(
    (state) =>
      state["externalAuditReducer"]
        .isCurrentContentTypeInvalidForReviewContractor,
    isEqual
  );
  const isProcessTemplateValid = useSelector(
    (state) => state["externalAuditReducer"].isProcessTemplateValid,
    isEqual
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );
  const auditPropertiesData = useSelector(
    (state: any) => state.auditPropertiesReducer.auditPropertiesData,
    isEqual
  );
  const requesterList = useSelector(
    (state) => state["auditPropertiesReducer"].requesterData,
    isEqual
  );
  const caseData = useSelector(
    (state) => state["caseDataReducer"].caseData,
    isEqual
  );

  const eaProcessTemplateId = useSelector(
    (state) =>
      state["auditPropertiesReducer"].auditPropertiesData.eaProcessTemplateId,
    isEqual
  );
  const termedProcessTemplate = useSelector(
    (state) =>
      state["auditPropertiesReducer"].auditPropertiesData.termedProcessTemplate,
    isEqual
  );
  const processTemplateDataSource = useSelector(
    (state) => state["auditPropertiesReducer"].processTemplateDataSource,
    isEqual
  );

  const originalClaimTypes = useSelector(
    (state) => state["auditPropertiesReducer"].originalClaimTypes
  );
  const isAuditPropertiesReadOnly = Boolean(caseData.eaAuditId) ? true : false;

  const processManagers = useSelector(
    (state) => state["auditPropertiesReducer"].processManagers,
    isEqual
  );
  const auditGroups = useSelector(
    (state) => state["auditPropertiesReducer"].auditGroups,
    isEqual
  );
  const recordSubmissionMethodEnumDisplayList = useSelector(
    (state: any) => state["caseDataReducer"].recordSubmissionMethodEnumDisplayList ?? state["caseSearchPageReducer"].recordSubmissionMethodEnumDisplayList,
    isEqual
  );

  const caseRoundRequesterList = useMemo(() => {
    if (requesterList?.length > 0) {
      var selectedRequester = requesterList?.find(
        (x) => x.eaRequesterId == caseData?.requesterId
      );
      var validRequester = requesterList?.filter((x) =>
        x.termDate
          ? compareDates(x.termDate, new Date()) == 1
            ? true
            : false
          : true && x.activeInd
      );
      if (
        selectedRequester?.eaRequesterId > 0 &&
        caseData?.requesterId > 0 &&
        !validRequester.find((x) => {
          return x.eaRequesterId == selectedRequester?.eaRequesterId;
        })
      ) {
        selectedRequester.activeInd = false;
        validRequester.push(selectedRequester);
      return validRequester;
      } else {
        return validRequester;
      }
    }
  }, [requesterList, caseData?.requesterId]);

  const dispatch = useDispatch();
  const reviewContractors = useSelector(
    (state: any) => state["auditPropertiesReducer"].reviewContractorList,
    isEqual
  );
  const reviewContractorContentTypeList = useSelector(
    (state: any) => state["auditPropertiesReducer"].reviewContractorContentTypeList,
    isEqual
  );
  const contentTypeList = useSelector(
    (state) => state["auditPropertiesReducer"].contentTypeList,
    isEqual
  );
  const validContentTypes = useSelector(
    (state) => state["externalAuditReducer"].validContentTypes,
    isEqual
  );
  const submissionMethod = useSelector(
    (state) => state["auditPropertiesReducer"].submissionMethod,
    isEqual
  );
  const processesTemplatesList = useSelector(
    (state) => state["auditPropertiesReducer"].processesTemplatesList,
    isEqual
  );
  const targetTypes2 = useSelector(
    (state) => state["auditPropertiesReducer"].targetTypes2,
    isEqual
  );
  const targetRationaleList = useSelector(
    (state) => state["auditPropertiesReducer"].targetRationaleList,
    isEqual
  );
  const auditStatus = useSelector(
    (state) => state["auditPropertiesReducer"].auditStatus,
    isEqual
  );
  const processTemplateRoundList = useSelector(
    (state) => state["externalAuditReducer"].processTemplateRoundList,
    isEqual
  );
  const eaAuditTypes = useSelector(
    (state) => state["auditPropertiesReducer"].eaAuditTypes
  );

  const currentUrl = new URL(window.location.href);
  const eMDRDocumentId = parseInt(currentUrl.searchParams.get("documentid")) || 0;
  const hasCaseSearchWithDocumentId =currentUrl.pathname.toLowerCase().includes("casesearch") &&currentUrl.searchParams.has("documentid");

  useEffect(() => {
    if(caseData?.eaAuditId)
    dispatch(getAuditData(caseData.eaAuditId));
  }, [caseData?.eaAuditId]);

useEffect(() => {
    if (targetRationaleList?.length == 0 || !targetRationaleList) {
      dispatch(actions.asyncOperationStart(GET_TARGET_RATIONALE_LOOKUP_DATA));
    }
    if (processesTemplatesList?.length == 0 || !processesTemplatesList) {
      dispatch(
        actions.asyncOperationStart(GET_TARGET_DATA_LOOKUPS, {
          eaAuditId: auditPropertiesData?.eaAuditId,
        })
      );
    }
    if (targetTypes2?.length == 0 || !targetTypes2) {
      dispatch(
        actions.asyncOperationStart(GET_CODE_TYPES_LOOKUPS, {
          eaAuditId: auditPropertiesData?.eaAuditId,
        })
      );
    }
    if(auditGroups?.length == 0 || !auditGroups){
      dispatch(
        actions.asyncOperationStart(GET_AUDIT_GROUPS, {
          eaAuditId: auditPropertiesData?.eaAuditId,
        })
      );
    }
   if (processManagers?.length == 0 || !processManagers){
      dispatch(
        actions.asyncOperationStart(
          GET_PROCESS_MANAGERS_LIST,
          "External Audit Creation"
        )
      );
    }

    dispatch(actions.asyncOperationStart(GET_AUDIT_STATUS, {}));
}, [caseData?.eaAuditId]);


const onRequesterChange = useCallback(
  (requesterId) => {
    callOperation(GET_EA_REQUESTER_BY_ID, { requesterId }).then((response) => {
      const eaAuditRound = {
        requesterId,
        rqstrOrganizationName: response?.rqstrOrganizationName,
        rqstrMainPhoneNumber: response?.rqstrMainPhoneNumber,
        rqstrContactName: response?.rqstrContactName,
        rqstrContactPhoneNumber: response?.rqstrContactPhoneNumber,
        rqstrContactEmail: response?.rqstrContactEmail,
        rqstrRecordSubmissionMethod: response?.rqstrRecordSubmissionMethod,
        rqstrRecordSubmissionValue: response?.rqstrRecordSubmissionValue,
        rqstrNotes: response?.rqstrNotes,
        rqstrRecordSubmissionMethodDisplayName:
          getRecordSubmissionMethodDisplayName(
            response?.rqstrRecordSubmissionMethod
          ),
      };

      dispatch({
        type: SET_CASE_FORM_DATA,
        data: {
          caseData: eaAuditRound,
        },
      });
    });
  },
  [dispatch,recordSubmissionMethodEnumDisplayList]
);
useEffect(() => {
  if (eMDRDocumentId > 0 && hasCaseSearchWithDocumentId) {
    callOperation(GET_AUDIT_PROPERTIES_DATA_BY_DOCUMENT_ID, {
      documentId: eMDRDocumentId,
    }).then((response) => {
      var data =response?.auditPropertiesData;
      const notificationDate =
        response?.auditPropertiesData?.notificationDate ?? "";

      if(data){dispatch({
        type: SET_AUDIT_PROPERTIES_DATA,
        data: {
          auditPropertiesData: {
            notificationDate,
          },
        },
      });
      if (data.eaRequesterId) {
        onRequesterChange(data.eaRequesterId);
      }}
    });
  }
}, [eMDRDocumentId, dispatch,onRequesterChange]);

const finalProcessTemplateList = useMemo(() => {
  if (processTemplateDataSource?.length > 0) {
    var validProcessTemplateList = cloneDeep(processTemplateDataSource);
    if (
      eaProcessTemplateId > 0 &&
      termedProcessTemplate?.eaProcessTemplateId > 0
    ) {
      validProcessTemplateList.push(termedProcessTemplate);
      return validProcessTemplateList;
    } else {
      return validProcessTemplateList;
    }
  } else {
    return [];
  }
}, [
  processTemplateDataSource?.length,
  eaProcessTemplateId,
  termedProcessTemplate,
]);
  const isCurrentReviewContractorValid = useMemo(
    () => {
      if (auditPropertiesData?.statusId == auditStatus?.find(x => x.statusCd == "Completed")?.statusId)
      var isAuditCompleted = true;
      if (reviewContractors?.length > 0 &&
      requesterList?.length > 0 &&
      caseData?.requesterId > 0 &&
      reviewContractorContentTypeList
    ) {
      var requester = requesterList?.find((obj) => {
        return obj.eaRequesterId === caseData?.requesterId;
      });
      if (requester && requester.recordSubmissionMethod?.toLowerCase() == "esmd") {
        var reviewContractor = reviewContractors?.find(obj => {
          return obj.reviewerCode === requester.recordSubmissionValue
        });
      }
      else {
        dispatch({
          type: SET_IS_REVIEW_CONTRACTOR_VALID_FOR_CURRENT_REQUESTER,
          data: true,
        });
        if (caseData.rqstrRecordSubmissionMethod?.toLowerCase() == "esmd") {
          var reviewContractor = reviewContractors?.find(obj => {
            return obj.reviewerCode === caseData?.rqstrRecordSubmissionValue
          });
          for (var key in reviewContractorContentTypeList) {
            if (key == reviewContractor?.reviewContractorId) {
              var validContentTypes = reviewContractorContentTypeList[key];
              break;
            }
          }
          dispatch({
            type: SET_VALID_CURRENT_CONTENT_TYPE_LIST,
            data: { validContentTypes: validContentTypes },
          });
          dispatch({
            type: SET_IS_CURRENT_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR,
            data: true,
          });
        }
        else {
          dispatch({
            type: SET_VALID_CURRENT_CONTENT_TYPE_LIST,
            data: { validContentTypes: [] },
          });
          dispatch({
            type: SET_IS_CURRENT_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR,
            data: true,
          });
        }
        return true;
      }
      if (reviewContractor && !reviewContractor.activeInd && !isAuditCompleted && reviewContractor.reviewerCode == caseData?.rqstrRecordSubmissionValue) {
        dispatch({
          type: SET_IS_REVIEW_CONTRACTOR_VALID_FOR_CURRENT_REQUESTER,
          data: false,
        });
        dispatch({
          type: SET_IS_CURRENT_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR,
          data: true,
        });
        for (var key in reviewContractorContentTypeList) {
          if (key == reviewContractor?.reviewContractorId) {
            var validContentTypes = reviewContractorContentTypeList[key];
            break;
          }
        }
        dispatch({
          type: SET_VALID_CURRENT_CONTENT_TYPE_LIST,
          data: { validContentTypes: validContentTypes },
        });
        return false;
      }
      else {
        for (var key in reviewContractorContentTypeList) {
          if (key == reviewContractor?.reviewContractorId) {
            var contentTypes = reviewContractorContentTypeList[key];
            var validContentTypes = contentTypes.filter((x) => { return x.activeInd });
            break;
          }
        }
        if (validContentTypes) {
          var contentType = validContentTypes.find((obj) => {
            return obj.eaContentTypeId === caseData?.eaContentTypeId;
          });
        }
        if (!contentType && caseData?.eaContentTypeId && !isAuditCompleted) {
          var invalidContentType = contentTypeList.find((obj) => {
            return obj.eaContentTypeId == caseData?.eaContentTypeId;
          })
          invalidContentType.activeInd = false;
          if (!(validContentTypes.find((x) => { return x.eaContentTypeId == caseData?.eaContentTypeId }))) {
            validContentTypes.push(invalidContentType);
          }

          //Checking For valid process template
          if (processTemplateRoundList?.length > 0 && processTemplateRoundList?.length >= caseData?.sequenceNo) {
            if (processTemplateRoundList[caseData?.sequenceNo - 1].eaContentTypeId == invalidContentType.eaContentTypeId) {
              dispatch({
                type: SET_IS_PROCESS_TEMPLATE_VALID,
                data: false,
              });
            }
            else {
              dispatch({
                type: SET_IS_PROCESS_TEMPLATE_VALID,
                data: true,
              });
            }
          }
          else {
            //no of rounds present in audit is more than present in process template
            dispatch({
              type: SET_IS_PROCESS_TEMPLATE_VALID,
              data: true,
            });
          }

          dispatch({
            type: SET_VALID_CURRENT_CONTENT_TYPE_LIST,
            data: { validContentTypes: validContentTypes },
          });
          dispatch({
            type: SET_IS_CURRENT_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR,
            data: false,
          });
        }
        else {
          dispatch({
            type: SET_IS_CURRENT_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR,
            data: true,
          });
          dispatch({
            type: SET_VALID_CURRENT_CONTENT_TYPE_LIST,
            data: { validContentTypes: validContentTypes },
          });
          dispatch({
            type: SET_IS_PROCESS_TEMPLATE_VALID,
            data: true,
          });
        }
        dispatch({
          type: SET_IS_REVIEW_CONTRACTOR_VALID_FOR_CURRENT_REQUESTER,
          data: true,
        });
        return true;
      }
    }
  },
  [reviewContractors?.length,
    requesterList?.length,
    caseData?.requesterId,
    caseData?.eaContentTypeId,
    reviewContractorContentTypeList?.length,
    processTemplateRoundList?.length,
    auditPropertiesData?.statusId,
    auditStatus?.length,
    caseData?.rqstrRecordSubmissionValue
    ]
  );

  var isActualSubmissionDatePopulated = cloneDeep(caseData?.roundData[0]?.actualSubmissionDate == null ? false : true)
  const recordSubmissionMethodEnums = useSelector(
    (state: any) => state["auditPropertiesReducer"].recordSubmissionMethodEnums,
    isEqual
  );

  const getRecordSubmissionMethodDisplayName = (recordSubmissionValue) =>{
    var recordSubmissionDisplayName = '';
    switch (recordSubmissionValue) {
      case recordSubmissionValue = recordSubmissionMethodEnums?.fax:
        return recordSubmissionDisplayName = recordSubmissionMethodEnumDisplayList.find(x=>x.value == recordSubmissionMethodEnums?.fax).displayName;
      case recordSubmissionValue = recordSubmissionMethodEnums?.website:
        return recordSubmissionDisplayName = recordSubmissionMethodEnumDisplayList.find(x=>x.value == recordSubmissionMethodEnums?.website).displayName;
      case recordSubmissionValue = recordSubmissionMethodEnums?.webPortal:
        return recordSubmissionDisplayName = recordSubmissionMethodEnumDisplayList.find(x=>x.value == recordSubmissionMethodEnums?.webPortal).displayName;
      case recordSubmissionValue = recordSubmissionMethodEnums?.mailingAddress:
        return recordSubmissionDisplayName = recordSubmissionMethodEnumDisplayList.find(x=>x.value == recordSubmissionMethodEnums?.mailingAddress).displayName;
      case recordSubmissionValue = recordSubmissionMethodEnums?.email:
        return recordSubmissionDisplayName = recordSubmissionMethodEnumDisplayList.find(x=>x.value == recordSubmissionMethodEnums?.email).displayName;
      case recordSubmissionValue = recordSubmissionMethodEnums?.other:
        return recordSubmissionDisplayName = recordSubmissionMethodEnumDisplayList.find(x=>x.value == recordSubmissionMethodEnums?.other).displayName;
      case recordSubmissionValue = recordSubmissionMethodEnums?.esMD:
        return recordSubmissionDisplayName = recordSubmissionMethodEnumDisplayList.find(x=>x.value == recordSubmissionMethodEnums?.esMD).displayName;
    }
  }
  const setProcessManagerToCurrentUser = () => {
    dispatch({
      type: SET_AUDIT_PROPERTIES_DATA,
      data: {
        auditPropertiesData: {
          processManagerId: currentUser.userId,
        },
      },
    });
};

  return (
    <div style={{marginRight: 10}}>
     <div className="top-margin">
      <ProcessTemplateComponent
        auditMode={Boolean(caseData.eaAuditId) ? auditModes.EDIT :auditModes.CREATE}
        finalProcessTemplateList={finalProcessTemplateList}
        isProcessTemplateValid={isProcessTemplateValid}
        isReadOnly={isAuditPropertiesReadOnly || Boolean(caseData.eaAuditId)}
        isSyncAuditAndCases={true}
      />
      </div>
      <div className="top-margin">
        <AuditGroupComponent
          mode={Boolean(caseData.eaAuditId) ? auditModes.EDIT :auditModes.CREATE}
          setProcessManagerToCurrentUser={setProcessManagerToCurrentUser}
          validateAuditGroup={caseDataValidationGroup}
          isReadOnly={isAuditPropertiesReadOnly}
          claimTypeCd={caseData.claimTypeCd}
          page={Boolean(caseData.eaAuditId)?CASE_ADD_LOCATIONS.AUDIT_PAGE: CASE_ADD_LOCATIONS.CASE_SEARCH_PAGE}
        />
      </div>
      <div className="top-margin">
        <MdaeSelectBox
          id={"ddlEaAuditType"}
          tabIndex={13.5}
          mdaeDropDownBoxTitle={"Audit Type"}
          displayExpr={"description"}
          valueExpr={"code"}
          readOnly={isAuditPropertiesReadOnly}
          required={!isAuditPropertiesReadOnly}
          dataSource={eaAuditTypes || []}
          mdaeDataUpdaterConfig={[
            {
              actionType: SET_AUDIT_PROPERTIES_DATA,
              reducerName: "auditPropertiesReducer",
              widgetOptionBindings: {
                value: "auditPropertiesData.eaAuditType",
              },
            },
          ]}
        >
          <Validator validationGroup={caseDataValidationGroup}>
            {!isAuditPropertiesReadOnly && <RequiredRule message="Audit Type is required" />}
          </Validator>
        </MdaeSelectBox>
      </div>
      <div className="top-margin">
        <MdaeSelectBox
          id={"ddlClaimType"}
          tabIndex={13}
          mdaeDropDownBoxTitle={"Claim Type"}
          displayExpr={"description"}
          required={!isAuditPropertiesReadOnly}
          readOnly={true}
          valueExpr={"code"}
          dataSource={originalClaimTypes || []}
          value = {caseData.claimTypeCd}
          onValueChanged={(e) => {
            if (e.value) {
              dispatch({ type: SHOW_LOADER });
              callOperation(GET_CODE_TYPES_LOOKUPS, {}).then((response) => {
                let filterdValue =
                  e.value === PROFESSIONAL
                    ? response.targetTypesList.filter(
                        (x) =>
                          x.displayName.toLocaleLowerCase() !==
                            "icd procedure" &&
                          x.displayName.toLocaleLowerCase() !== "drg"
                      )
                    : response.targetTypesList;
                dispatch({
                  type: SET_TARGET_TYPES_LOOKUP,
                  targetTypes: filterdValue,
                  currentTagetType: 1,
                });
                dispatch({
                  type: SET_TARGET_TYPES_LOOKUP,
                  targetTypes2: filterdValue,
                  currentTagetType: 2,
                });
                dispatch({ type: HIDE_LOADER });
              });
            }
          }}
          mdaeDataUpdaterConfig={[
            {
              actionType: SET_CASE_FORM_DATA,
              reducerName: "caseDataReducer",
              widgetOptionBindings: {
                value: "caseData.claimTypeCd",
              },
            },
          ]}
        >
          <Validator validationGroup={caseDataValidationGroup}>
            {!isAuditPropertiesReadOnly && <RequiredRule message="Claim Type is required" />}
          </Validator>
        </MdaeSelectBox>
      </div>
      <div className="top-margin">
        <MdaeSelectBox
          id={"ddlSource"}
          tabIndex={12}
          mdaeDropDownBoxTitle={"Initial Source"}
          displayExpr={"eaSourceName"}
          readOnly={isAuditPropertiesReadOnly}
          valueExpr={"eaSourceId"}
          value={auditPropertiesData?.eaSourceId}
          mdaeDataUpdaterConfig={[
            {
              actionType: SET_AUDIT_PROPERTIES_DATA,
              reducerName: "auditPropertiesReducer",
              widgetOptionBindings: {
                value: "auditPropertiesData.eaSourceId",
              },
            },
            {
              actionType: GET_TARGET_DATA_LOOKUPS,
              isAsyncComplete: true,
              widgetOptionBindings: {
                dataSource: "sorcesList",
              },
            },
          ]}
        ></MdaeSelectBox>
      </div>
      <MdaeSelectBox
        id={"ddlRequesterOrganization"}
        mdaeDropDownBoxTitle={"Current Round Requester Organization"}
        className={isCurrentRequesterReviewContractorValid ? "top-margin" : "top-margin invalid-review-contractor-for-requester"}
        displayExpr={"organizationName"}
        valueExpr={"eaRequesterId"}
        dataSource={caseRoundRequesterList || []}
        value={caseData?.requesterId}
        required={!isActualSubmissionDatePopulated}
        readOnly={isActualSubmissionDatePopulated}
        isValid={isCurrentReviewContractorValid}
        itemRender={(e) => {
          if (e.activeInd) {
            return <div>{e.organizationName}</div>;
          }
        }}
        onValueChanged={(e) => {
          if (e.event && e.value) {
            onRequesterChange(e.value);
          }
        }}
        elementAttr={{
          title: isCurrentRequesterReviewContractorValid
            ? ""
            : "This Requester contains a Review Contractor that is no longer valid. Please update the Review Contractor",
        }}
      >
        <Validator validationGroup={caseDataValidationGroup}>
          {!isActualSubmissionDatePopulated && (
            <RequiredRule message="Current Round Requester Organization is required" />
          )}
        </Validator>
      </MdaeSelectBox>
      <div className="content-type-field top-margin">
        <MdaeSelectBox
          id={"ddlContentType"}
          mdaeDropDownBoxTitle={"Content Type"}
          dataSource={validContentTypes || []}
          value={caseData.eaContentTypeId}
          readOnly={isActualSubmissionDatePopulated || caseData?.rqstrRecordSubmissionMethod?.toLowerCase() !== "esmd"}
          className={isCurrentContentTypeInvalidForReviewContractor ? "" : "invalid-content-type"}
          isValid={(isCurrentContentTypeInvalidForReviewContractor && caseData?.eaContentTypeId > 0) || caseData?.rqstrRecordSubmissionMethod?.toLowerCase() !== "esmd"}
          required={caseData?.rqstrRecordSubmissionMethod?.toLowerCase() === "esmd" && !isActualSubmissionDatePopulated}
          itemRender={(item) => {
            if (item && item.activeInd) {
              return (
                item &&
                item.eaContentTypeCode + " - " + item.eaContentTypeDescription
              );
            }
          }}
          displayExpr={(item) => {
            return (
              item &&
              item.eaContentTypeCode +
              " - " +
              item.eaContentTypeDescription
            );
          }}
          valueExpr={"eaContentTypeId"}
          elementAttr={{
            title: isCurrentContentTypeInvalidForReviewContractor
              ? ""
              : "The selected Content Type is no longer valid for the Review Contractor associated with this Requester. Please update your Content Type selection.",
          }}
          onValueChange={(e) => {
            dispatch({
              type: SET_CASE_FORM_DATA,
              data: {
                caseData: { eaContentTypeId: e },
              },
            });
          }}
        >
          <Validator validationGroup={caseDataValidationGroup}>
          {(!isActualSubmissionDatePopulated && caseData?.rqstrRecordSubmissionMethod?.toLowerCase() === "esmd") && (
              <RequiredRule message="Content Type is required" />
            )}
          </Validator>
        </MdaeSelectBox>
        {caseData?.rqstrRecordSubmissionMethod?.toLowerCase() ===
          "esmd" && (
          <span
            className="case-search-info-icon content-type-info-icon"
            title={
              "Click here to open the Content Maintenance page for more information"
            }
            onClick={onContentTypeClick}
          >
            <i className="img-circle fa fa-info-circle account-case-search-info-circle"></i>
          </span>
        )}
      </div>

      <MdaeTextBox
        id={"txtReferenceId"}
        className={"top-margin"}
        readOnly={true}
        mdaeTextBoxTitle={"Audit Reference ID"}
        value={auditPropertiesData?.referenceId}
      ></MdaeTextBox>
      <div className="top-margin">
        <CaseProcessManagerComponent
          validationGroup={caseDataValidationGroup}
          readOnly={false}
        />
      </div>
      <div className="top-margin">
        <StartDateComponent
          mode={auditModes.CREATE}
          validationGroup={caseDataValidationGroup}
          isReadOnly={isAuditPropertiesReadOnly}
          title="Audit Start Date"
        />
      </div>
      <MdaeDateBox
        id="dtCaseDetailNotificationDate"
        className="top-margin"
        tabIndex={6}
        readOnly={isAuditPropertiesReadOnly}
        required={!isAuditPropertiesReadOnly}
        value={auditPropertiesData.notificationDate}
        onValueChanged={(e) => {
          dispatch({
            type: SET_AUDIT_PROPERTIES_DATA,
            data:{
              auditPropertiesData: {
                notificationDate: e.value,
              },
            }
          });
        }}
        mdaeDateBoxTitle="Notification Date"
      >
        <Validator validationGroup={caseDataValidationGroup}>
        {!isAuditPropertiesReadOnly && (
              <RequiredRule message="Notification Date" />
            )}
        </Validator>
      </MdaeDateBox>
      <MdaeTextBox
        id={"txtAlternateCaseId"}
        className={"top-margin"}
        mdaeTextBoxTitle={"Alternate Case ID"}
        maxLength={50}
        value = {caseData.altEaCaseId}
        mdaeDataUpdaterConfig={[
          {
            actionType: SET_CASE_FORM_DATA,
            reducerName: "caseDataReducer",
            widgetOptionBindings: {
              value: "caseData.altEaCaseId",
            },
          },
        ]}
      ></MdaeTextBox>
      <MdaeTextBox
        id={"txtContactName"}
        className={"top-margin"}
        readOnly={isActualSubmissionDatePopulated}
        mdaeTextBoxTitle={"Contact Name"}
        value = {caseData.rqstrContactName}
        mdaeDataUpdaterConfig={[
          {
            actionType: SET_CASE_FORM_DATA,
            reducerName: "caseDataReducer",
            widgetOptionBindings: {
              value: "caseData.rqstrContactName",
            },
          },
        ]}
      ></MdaeTextBox>
      <MdaeTextBox
        id={"txtPhoneContact"}
        className={"top-margin"}
        readOnly={isActualSubmissionDatePopulated}
        mdaeTextBoxTitle={"Phone- Contact"}
        value = {caseData.rqstrContactPhoneNumber}
        mdaeDataUpdaterConfig={[
          {
            actionType: SET_CASE_FORM_DATA,
            reducerName: "caseDataReducer",
            widgetOptionBindings: {
              value: "caseData.rqstrContactPhoneNumber",
            },
          },
        ]}
      ></MdaeTextBox>
      <MdaeTextBox
        id={"txtEmailContact"}
        className={"top-margin"}
        readOnly={isActualSubmissionDatePopulated}
        mdaeTextBoxTitle={"Email- Contact"}
        value = {caseData.rqstrContactEmail}
        mdaeDataUpdaterConfig={[
          {
            actionType: SET_CASE_FORM_DATA,
            reducerName: "caseDataReducer",
            widgetOptionBindings: {
              value: "caseData.rqstrContactEmail",
            },
          },
        ]}
      ></MdaeTextBox>
      <MdaeSelectBox
        id={"ddlSubmissionMethod"}
        mdaeDropDownBoxTitle={"Submission Method"}
        className={"top-margin"}
        displayExpr={"displayName"}
        valueExpr={"value"}
        dataSource={submissionMethod || []}
        readOnly={isActualSubmissionDatePopulated}
        required={!isActualSubmissionDatePopulated}
        value = {caseData.rqstrRecordSubmissionMethod}
        onValueChanged={(e)=>{
          if (e.event && e.value) {
            dispatch({
              type: SET_CASE_FORM_DATA,
              data: {
                caseData: {
                  rqstrRecordSubmissionMethodDisplayName:getRecordSubmissionMethodDisplayName(e.value)
                },
              },
            });
          }
        }}
        mdaeDataUpdaterConfig={[
          {
            actionType: SET_CASE_FORM_DATA,
            reducerName: "caseDataReducer",
            widgetOptionBindings: {
              value: "caseData.rqstrRecordSubmissionMethod",
            },
          },
        ]}
      >
        <Validator validationGroup={caseDataValidationGroup}>
          {!isActualSubmissionDatePopulated && (
            <RequiredRule message="Submission Method is required" />
          )}
        </Validator>
      </MdaeSelectBox>
      {caseData?.rqstrRecordSubmissionMethod?.toLowerCase() !==
        "esmd" && (
        <>
          {caseData?.rqstrRecordSubmissionMethod ==
          recordSubmissionMethodEnums?.fax ? (
            <MdaeTextBox
              id={"txtFaxRecordSubmissionData"}
              mdaeTextBoxTitle={"Fax"}
              mask="(000)-000-0000"
              className={"top-margin"}
              readOnly={isActualSubmissionDatePopulated}
              value={caseData.rqstrRecordSubmissionValue}
              onValueChanged={(e) => {
                  if (e.value) {
                    if (e.event) {
                      dispatch({
                        type: SET_CASE_FORM_DATA,
                        data: {
                          caseData: { rqstrRecordSubmissionValue: e.value }
                        },
                      });
                    }
                  }
              }}
            >
              <Validator validationGroup={caseDataValidationGroup}>
                <CustomRule
                  validationCallback={(e) => {
                    if(!e.value) return true;
                      if (
                        /^(\(?\d{3}?\)?\d{3}?(\-)?\d{4})$/.test(
                          e.value
                        )
                      )
                      return true;
                    else return false;
                  }}
                  message="Enter valid fax."
                />
              </Validator>
            </MdaeTextBox>
          ) : null}
          {caseData?.rqstrRecordSubmissionMethod ==
          recordSubmissionMethodEnums?.website ? (
            <MdaeTextBox
              id={"txtWebsiteRecordSubmissionData"}
              mdaeTextBoxTitle={"Website"}
              maxLength={200}
              className={"top-margin"}
                readOnly={isActualSubmissionDatePopulated}
                value={caseData.rqstrRecordSubmissionValue}
                onValueChanged={(e) => {
                  if (e.value) {
                    if (e.event) {
                      dispatch({
                        type: SET_CASE_FORM_DATA,
                        data: {
                          caseData: { rqstrRecordSubmissionValue: e.value }
                        },
                      });
                    }
                  }
                }}
            >
              <Validator validationGroup={caseDataValidationGroup}>
                <CustomRule
                  validationCallback={(e) => {
                    if (
                      /^[a-zA-Z0-9-._~:/?#[\]\@!$&'()*+,;=]+$/.test(
                        e.value
                      )
                    )
                      return true;
                    else return false;
                  }}
                  message="Enter valid website."
                />
              </Validator>
            </MdaeTextBox>
          ) : null}
          {caseData?.rqstrRecordSubmissionMethod ==
          recordSubmissionMethodEnums?.webPortal ? (
            <MdaeTextBox
              id={"txtWebPortalRecordSubmissionData"}
              mdaeTextBoxTitle={"Web Portal"}
              maxLength={200}
              className={"top-margin"}
                readOnly={isActualSubmissionDatePopulated}
                value={caseData.rqstrRecordSubmissionValue}
                onValueChanged={(e) => {
                  if (e.value) {
                    if (e.event) {
                      dispatch({
                        type: SET_CASE_FORM_DATA,
                        data: {
                          caseData: { rqstrRecordSubmissionValue: e.value }
                        },
                      });
                    }
                  }
                }}
            >
              <Validator validationGroup={caseDataValidationGroup}>
                <CustomRule
                  validationCallback={(e) => {
                    if (
                      /^[a-zA-Z0-9-._~:/?#[\]\@!$&'()*+,;=]+$/.test(
                        e.value
                      )
                    )
                      return true;
                    else return false;
                  }}
                  message="Enter valid web portal."
                />
              </Validator>
            </MdaeTextBox>
          ) : null}
          {caseData?.rqstrRecordSubmissionMethod ==
          recordSubmissionMethodEnums?.mailingAddress ? (
            <MdaeTextBox
              id={"txtMailingAddressRecordSubmissionData"}
              mdaeTextBoxTitle={"Mailing Address"}
              maxLength={200}
              className={"top-margin"}
                readOnly={isActualSubmissionDatePopulated}
                value={caseData.rqstrRecordSubmissionValue}
                onValueChanged={(e) => {
                  if (e.value) {
                    if (e.event) {
                      dispatch({
                        type: SET_CASE_FORM_DATA,
                        data: {
                          caseData: { rqstrRecordSubmissionValue: e.value }
                        },
                      });
                    }
                  }
                }}
            >
              <Validator validationGroup={caseDataValidationGroup}></Validator>
            </MdaeTextBox>
          ) : null}
          {caseData?.rqstrRecordSubmissionMethod ==
            recordSubmissionMethodEnums?.email ? (
              <MdaeTextBox
                id={"txtEmailRecordSubmissionData"}
                mdaeTextBoxTitle={"Email"}
                maxLength={200}
                className={"top-margin"}
                readOnly={isActualSubmissionDatePopulated}
                value={caseData.rqstrRecordSubmissionValue}
                onValueChanged={(e) => {
                  if (e.value) {
                    if (e.event) {
                      dispatch({
                        type: SET_CASE_FORM_DATA,
                        data: {
                          caseData: { rqstrRecordSubmissionValue: e.value }
                        },
                      });
                    }
                  }
                }}
            >
              <Validator validationGroup={caseDataValidationGroup}>
                <EmailRule message="Email is invalid" />
              </Validator>
            </MdaeTextBox>
          ) : null}
          {caseData?.rqstrRecordSubmissionMethod ==
          recordSubmissionMethodEnums?.other ? (
            <MdaeTextBox
              id={"txtOtherRecordSubmissionData"}
              mdaeTextBoxTitle={"Other"}
              maxLength={200}
              className={"top-margin"}
                readOnly={isActualSubmissionDatePopulated}
                value={caseData.rqstrRecordSubmissionValue}
                onValueChanged={(e) => {
                  if (e.value) {
                    if (e.event) {
                      dispatch({
                        type: SET_CASE_FORM_DATA,
                        data: {
                          caseData: { rqstrRecordSubmissionValue: e.value }
                        },
                      });
                    }
                  }
                }}
            >
              <Validator validationGroup={caseDataValidationGroup}></Validator>

            </MdaeTextBox>
          ) : null}
        </>
      )}
      {caseData?.rqstrRecordSubmissionMethod?.toLowerCase() ===
        "esmd" && (
        <MdaeSelectBox
          id={"txtSubmissionValue"}
          className={
            isCurrentRequesterReviewContractorValid
              ? "top-margin"
              : "top-margin invalid-review-contractor"
          }
          readOnly={isActualSubmissionDatePopulated}
          displayExpr={"reviewerDescription"}
          valueExpr={"reviewerCode"}
          value = {caseData.rqstrRecordSubmissionValue}
          dataSource={reviewContractors || []}
          mdaeDropDownBoxTitle={"Review Contractor"}
          isValid={isCurrentRequesterReviewContractorValid && caseData?.rqstrRecordSubmissionValue != null}
          elementAttr={{
            title: isCurrentRequesterReviewContractorValid
              ? ""
              : "This Review Contractor is no longer valid. Please select another eligible Review Contractor and update the Review Contractor for your Requester",
          }}
          mdaeDataUpdaterConfig={[
            {
              actionType: SET_CASE_FORM_DATA,
              reducerName: "caseDataReducer",
              widgetOptionBindings: {
                value: "caseData.rqstrRecordSubmissionValue",
              },
            },
          ]}
        >
          <Validator validationGroup={caseDataValidationGroup}></Validator>

        </MdaeSelectBox>
      )}
      <MdaeTextArea
        id={"txtRequesterNotes"}
        className={"top-margin"}
        readOnly={isActualSubmissionDatePopulated}
        mdaeTextAreaTitle={"Requester Notes"}
        value = {caseData.rqstrNotes}
        mdaeDataUpdaterConfig={[
          {
            actionType: SET_CASE_FORM_DATA,
            reducerName: "caseDataReducer",
            widgetOptionBindings: {
              value: "caseData.rqstrNotes",
            },
          },
        ]}
      ></MdaeTextArea>
      <MdaeTextBox
        id={"txtMDauditCaseId"}
        className={"top-margin"}
        readOnly={true}
        mdaeTextBoxTitle={"MDaudit Case ID"}
        value={`${props.mdAuditCaseId?props.mdAuditCaseId:''}`}
      ></MdaeTextBox>
    </div>
  );
}

interface ITasksTab{

}

const TasksTab: React.FC<ITasksTab> = (props) => {
  const dispatch = useDispatch();
  const {
    getAssignedUserList,
    onUserTaskStatusChanged,
  } = useTaskCommonFunctions();
  const [dataSourceStoreId, _] = useState(new Guid().toString());
  const userTaskFormData = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskFormData,
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual,
  );
  const qaReviewPermission = getUserPermissionObject(
    "ALL_AUDITS_FOR_QA_REVIEW||MY_AUDITS_FOR_QA_REVIEW",
    currentUser,
  );
  const taskGroupPermission = getUserPermissionObject(
    "TASK_GROUPS",
    currentUser,
  );
  const isExternalUser = useMemo(
    () =>
      hasAnyFeatureGroupAccess([FG_EXTERNAL_USER_TASK_EDITING], currentUser),
    [currentUser],
  );

  const userTaskPopupMode = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskPopupMode,
    isEqual,
  );
  const currentAttachedLevelName = useSelector(
    (state) => state["userTaskListReducer"].currentAttachedLevelName,
    isEqual
  );
  const userTaskStatusList = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskStatusList,
    isEqual,
  );
  const auditGroupId = useSelector(
    (state) => state["caseDetailReducer"].caseDetailData.auditGroupId,
    isEqual,
  );
  const eaCaseDetailsTabPanelSelectedIndex = useSelector(
    (state) => state["caseDetailReducer"].eaCaseDetailsTabPanelSelectedIndex,
    isEqual,
  );
  const attachLevelEnums = useSelector(
    (state: any) => state["userTaskListReducer"].attachLevelEnums,
    isEqual,
  );
  const isSelectExternalUserPopupVisible = useSelector(
    (state: any) => state.userTaskListReducer.isSelectExternalUserPopupVisible,
    isEqual
  );

  const isSelectAssignedGroupUserPopupVisible = useSelector(
    (state: any) =>
      state.userTaskListReducer.isSelectAssignedGroupUserPopupVisible
  );

  const assignedUserType = useSelector(
    (state: any) => state.userTaskListReducer.assignedUserType,
  );
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: actions.asyncOperationStart,
    },
    dispatch,
  );

  const hasTaskManagerAccess =
    (qaReviewPermission.hasAllAuditsForQaReviewUpdateAccess &&
      qaReviewPermission.hasMyAuditsForQaReviewUpdateAccess) ||
    (currentUser?.isTaskHQAccessEnabled &&
      window.location.pathname.toLowerCase().includes("audit/taskhq"));
  const hasTaskGroupAccessOnly =
    taskGroupPermission.hasUpdateAccess &&
    !(
      qaReviewPermission.hasAllAuditsForQaReviewUpdateAccess &&
      qaReviewPermission.hasMyAuditsForQaReviewUpdateAccess
    );

  const isEditMode = userTaskPopupMode === USER_TASK_POPUP_MODE.EDIT;
  return (
    <>
      <div
        className="widget-separation-margin-top"
        style={{ display: "flex", alignItems: "center" }}
      >
        <CompleteTaskCheckBoxComponent
          isEditMode={isEditMode}
          hasTaskManagerAccess={hasTaskManagerAccess}
          width={150}
        />
        <MdaeButton
          id={"btnCaseViewUploadTaskDocument"}
          role={"dxButton"}
          icon={"dx-icon upload-icon"}
          hint="Upload Documents to Task"
          className="data-grid-toolbar-button"
          onClick={() => {
            toggleEditDocumentPopupVisible(
              dispatch,
              true,
              dataSourceStoreId,
              "Upload Document",
              DOCUMENT_POPUP_MODE.UPLOAD,
              {
                attachedLevelId: userTaskFormData.userTaskId,
                attachedLevelName: "TS",
                documentId: 0,
                documentName: "",
                documentCategoryId: null,
              },
            );
          }}
        ></MdaeButton>
      </div>
      <div className="widget-separation-margin-top">
        <MdaeTextBox
          id="txtCaseTaskTitle"
          mdaeTextBoxTitle={"Task"}
          disabled={true}
          name="refTaskName"
          value={userTaskFormData.refTaskName}
          mdaeDataUpdaterConfig={[
            {
              actionType: SET_USER_TASK_FORM_DATA,
              reducerName: "userTaskListReducer",
              widgetOptionBindings: {
                value: "userTaskFormData.refTaskName",
              },
            },
          ]}
        />
      </div>
      <div className="widget-separation-margin-top">
        {TaskStatusComponent(
          userTaskStatusList,
          assignedUserType,
          userTaskFormData,
          hasTaskManagerAccess,
          onUserTaskStatusChanged,
          caseDataValidationGroup,
        )}
      </div>

      <div className="widget-separation-margin-top">
        {CompletedByComponent(
          assignedUserType,
          userTaskFormData,
          hasTaskManagerAccess,
          isExternalUser,
          false,
          auditGroupId,
          isEditMode,
          getAssignedUserList,
          dispatch,
        )}
      </div>

      <div className="widget-separation-margin-top">
        {CompletedOnComponent(
          dispatch,
          isEditMode,
          assignedUserType,
          userTaskFormData,
          hasTaskManagerAccess,
          isExternalUser,
        )}
      </div>
      <div className="widget-separation-margin-top">
        {DueDateComponent(
          dispatch,
          assignedUserType,
          userTaskFormData,
          hasTaskManagerAccess,
          isExternalUser,
          caseDataValidationGroup,
        )}
      </div>

      <div className="widget-separation-margin-top">
        {AsignedToComponent(
          false,
          auditGroupId,
          userTaskFormData,
          hasTaskManagerAccess,
          hasTaskGroupAccessOnly,
          isExternalUser,
          getAssignedUserList,
          dispatch,
          asyncAction,
          caseDataValidationGroup,
        )}
      </div>

      <div className="widget-separation-margin-top">
        {AuditorNotesComponent(
          dispatch,
          false,
          isExternalUser,
          userTaskFormData,
          attachLevelEnums,
          assignedUserType,
          'auto',
          currentAttachedLevelName,
          userTaskPopupMode
        )}
      </div>

      <div className="widget-separation-margin-top">
        {" "}
        {ManagerNotesComponent(
          assignedUserType,
          hasTaskManagerAccess,
          userTaskFormData,
          dispatch,
        )}
      </div>

      <div className="widget-separation-margin-top">
        {RescheduledDateComponent(
          dispatch,
          assignedUserType,
          userTaskFormData,
          hasTaskManagerAccess,
          isExternalUser,
        )}
      </div>

      <div className="widget-separation-margin-top">
        {ScheduledTimeComponent(
          dispatch,
          assignedUserType,
          userTaskFormData,
          hasTaskManagerAccess,
          isExternalUser,
        )}
      </div>

      <div className={"widget-separation-margin-top"}>
        {TotalTimeComponent(
          dispatch,
          assignedUserType,
          userTaskFormData,
          hasTaskManagerAccess,
          isExternalUser,
        )}
      </div>

      <div className="widget-separation-margin-top">
        {SchedulingNotesComponent(
          dispatch,
          userTaskFormData,
          assignedUserType,
          isExternalUser,
        )}
      </div>

      <EditDocumentPopup
        doNotRefreshDataGrid={true}
        parentAttachmentLevelId={userTaskFormData.userTaskId}
        parentAttachmentLevelName="TS"
        taskAttachmentLevel={userTaskFormData.level}
        uniqueId={dataSourceStoreId}
      />
      {isSelectExternalUserPopupVisible  && (eaCaseDetailsTabPanelSelectedIndex==0) && (
        <SelectExternalUser
          getAssignedUserList={getAssignedUserList}
          auditGroupId={userTaskFormData.auditGroupId}
        ></SelectExternalUser>
      )}
      {isSelectAssignedGroupUserPopupVisible && (eaCaseDetailsTabPanelSelectedIndex==0) && (
          <SelectAssignedGroupUser
            getAssignedUserList={getAssignedUserList}
            auditGroupId={ userTaskFormData.auditGroupId }
          ></SelectAssignedGroupUser>
        )}
    </>
  );
};

export const toggleCaseDataValidationMode = (dispatch, mode) => {
  dispatch({
    type: SET_CASE_DATA_VALIDATION_MODE,
    data: { caseDataValidationMode: mode },
  });
};

interface ICaseDataProps {
  eaCaseId: number;
  mdAuditCaseId: number;
}
const CASE_PROPERTIES_SECTION_WIDTH = "CASE_PROPERTIES_SECTION_WIDTH";
const CaseData: React.FC<ICaseDataProps> = (props) => {
  const dispatch = useDispatch();

  const [caseRoundOutcomeSelectBoxInstance, setCaseRoundOutcomeSelectBoxInstance] = useState(null);
  const [caseRoundDataAccordionInstance, setCaseRoundDataAccordionInstance] = useState(null);

  const caseDataValidationMode = useSelector(
    (state) => state["caseDataReducer"].caseDataValidationMode,
    isEqual
  );
  const caseDataAccordionSelectedKeys = useSelector(
    (state) => state["caseDataReducer"].caseDataAccordionSelectedKeys,
    isEqual
  );
  const caseData = useSelector(
    (state) => state["caseDataReducer"].caseData,
    isEqual
  );
  const roundData = useSelector(
    (state) => state["caseDataReducer"].caseData?.roundData,
    isEqual
  );
  const caseDetailPopupMode = useSelector(
    (state) =>
      state["caseDetailReducer"].caseDetailData.mode
  );
  const selectedRoundDataTabIndex = useSelector(
    (state) => state["caseDataReducer"].roundDataSelectedTab || {},
    isEqual
  );

  const activeRoundCaseData = useSelector(
    (state) => first(state["caseDataReducer"].caseData?.roundData),
    isEqual
  );
  const caseRoundOutcomeList = useSelector(
    (state: any) => state["outcomesReducer"].caseRoundOutcomeList,
    isEqual
  );

  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );

  const hasAuditACaseAccess = useMemo(
    () => hasAnyFeatureGroupAccess([FG_AUDIT_A_CASE], currentUser),
    [currentUser]
  );
  const isExternalAuditReadOnly = useSelector(
    (state) => state["auditPropertiesReducer"].isExternalAuditReadOnly,
    isEqual
  );
  const hasEditAccess = hasAuditACaseAccess && !isExternalAuditReadOnly;

  const isRoundLineLevelEnabledFlag = isRoundLineLevelEnabled(caseData);

  const handleSelectedIndexChange = useCallback(
    (roundId, tabIndex) => {
      dispatch({
        type: SET_ROUND_DATA_SELECTED_TAB,
        data: { roundId, tabIndex },
      });
    },
    [dispatch]
  );

  const roundAccordionUI = useMemo(
    () => (
      <MdaeAccordion
        dataSource={roundData || []}
        collapsible={true}
        multiple={true}
        id={"pnlCaseDataTabRoundDataAccordion"}
        onInitialized={(e) => {
          setCaseRoundDataAccordionInstance(e.component);
        }}
        keyExpr={"eaRoundCaseId"}
        mdaeDataUpdaterConfig={[
          {
            actionType: SET_CASE_DATA_ACCORDION_SELECTED_KEYS,
            reducerName: "caseDataReducer",
            widgetOptionBindings: {
              selectedItemKeys: "caseDataAccordionSelectedKeys",
            },
          },
        ]}
        itemTitleRender={(data) => {
          return (
            <div className={"accordion-title"}>
              {`${
                data?.eaProcessTemplateRoundName == null
                  ? "Round "
                  : `${data?.sequenceNo}: ${data?.eaProcessTemplateRoundName}`
              } ${
                data?.eaProcessTemplateRoundName == null ? data?.sequenceNo : ""
              } - ${data?.rqstrOrganizationName} ${
                data?.roundEndDate ? " " : " In-Progress"
              } (${convertDate(data?.roundStartDate)} - ${convertDate(
                data?.roundEndDate
              )})`}
            </div>
          );
        }}
        itemRender={(currentRoundCaseData) => {
          let newRoundOutcomeList = [...caseRoundOutcomeList];
          if (currentRoundCaseData.isRoundOutcomeTermed) {
            var termedOutcome = {
              eaOutcomeName: currentRoundCaseData.roundOutcomeName,
              eaOutcomeId: currentRoundCaseData.roundOutcomeId,
              activeInd: false,
            };
            newRoundOutcomeList = [...caseRoundOutcomeList, termedOutcome];
          }
          return roundCaseAccordionItemRender(
            dispatch,
            roundData,
            currentRoundCaseData,
            activeRoundCaseData,
            hasEditAccess,
            newRoundOutcomeList,
            caseDataValidationMode,
            setCaseRoundOutcomeSelectBoxInstance,
            caseRoundDataAccordionInstance,
            selectedRoundDataTabIndex,
            handleSelectedIndexChange,
            isRoundLineLevelEnabledFlag
          );
        }}
        onContentReady={(e) => {
          $(e.element)
            .find(".dx-accordion-item-title")
            .addClass("application-section-primary-background-color");
        }}
      ></MdaeAccordion>
    ),
    [
      (first(roundData) as any)?.roundSubmissionDeadline,
      JSON.stringify(roundData?.map((x) => x.roundDeterminationDate)),
      roundData?.length,
      caseRoundDataAccordionInstance,
      caseDataAccordionSelectedKeys,
      caseData?.eaCaseId,
      caseDataValidationMode,
      selectedRoundDataTabIndex,
      isRoundLineLevelEnabledFlag
    ]
  );

  return (
    <Resizable
      resizableContent={<CasePropertiesComponent />}
      resizableContentPosition={"right"}
      minSize={350}
      defaultSize={350}
      storeSizeInUserPreferences={true}
      componentKey={CASE_PROPERTIES_SECTION_WIDTH}
      stickyToggle={true}
    >

       <ValidationGroup
        key={caseDataValidationGroup}
        id={caseDataValidationGroup}
      >
        <div className={"case-data-content"}>
          <div className={"case-data-fields"}>
            <CollapsiblePanel
              title="Case Information"
              openByDefault
              style={{ marginRight: 5 }}
              titleRender={() => {
                return (
                  <div
                    className={
                      "accordion-title application-section-primary-background-color"
                    }
                  >
                    Case Information
                  </div>
                );
              }}
            >
              <CaseInformationComponent />
            </CollapsiblePanel>
            {caseDetailPopupMode !== CASE_DETAIL_POPUP_MODES.CREATE && (
              <div className={"round-accordion"}>
                <div
                  className={
                    "round-content top-margin application-section-primary-color"
                  }
                >
                  <div style={{ display: "flex" }}>
                    <div style={{ flexGrow: 1 }}>Round Data</div>{" "}
                    <div className="advance-round-case-level">
                      <MdaeButton
                        className="remove-button-styles advance-round-case-level-btn"
                        id="btnCaseLevelAdvanceToNextRound"
                        disabled={!hasEditAccess}
                        role="secondary"
                        text="Advance To Next Round"
                        onClick={() => {
                          if (activeRoundCaseData) {
                            const hasRoundOutcome = !!activeRoundCaseData.roundOutcomeId;
                            const hasRoundDeterminationDate = !!activeRoundCaseData.roundDeterminationDate;
                            const hasActualSubmissionDate = !!activeRoundCaseData.actualSubmissionDate;
                            const hasCaseStatus = !!caseData.statusId;
                            const hasStartDate = !!activeRoundCaseData.roundStartDate;
                            const warningData = {
                              ...defaultCaseDataWarningPopupData,
                              hasRoundDeterminationDate,
                              hasActualSubmissionDate,
                              hasRoundOutcome,
                              hasCaseStatus,
                              hasStartDate,
                            };
                            if (!hasCaseStatus)
                              toggleEaCaseDataWarningPopupVisible(
                                dispatch,
                                true,
                                EA_CASE_DATA_WARNING_POPUP_MODES.CASE_STATUS_IS_REQUIRED,
                                { ...warningData }
                              );
                            else if (!hasRoundOutcome)
                              toggleEaCaseDataWarningPopupVisible(
                                dispatch,
                                true,
                                EA_CASE_DATA_WARNING_POPUP_MODES.ROUND_OUTCOME_IS_REQUIRED_WARNING,
                                { ...warningData }
                              );
                            else {
                              if (
                                isSelectedOutcomeOfTypeWillNotAppeal(
                                  caseRoundOutcomeList,
                                  activeRoundCaseData.roundOutcomeId
                                )
                              )
                                toggleEaCaseDataWarningPopupVisible(
                                  dispatch,
                                  true,
                                  EA_CASE_DATA_WARNING_POPUP_MODES.ROUND_OUTCOME_OF_TYPE_NOT_APPEAL_IS_SELECTED,
                                  { ...warningData }
                                );
                              else
                                toggleEaCaseDataWarningPopupVisible(
                                  dispatch,
                                  true,
                                  EA_CASE_DATA_WARNING_POPUP_MODES.ADVANCE_TO_NEXT_ROUND,
                                  { ...warningData }
                                );
                            }
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                {roundAccordionUI}
              </div>
            )}
          </div>
          <div
            className="case-data-side-panel"
          >

          </div>
          {/* Case properties component moved */}
          {/* warning popup */}
          <EACaseDataWarningPopup
            caseRoundOutcomeSelectBoxInstance={
              caseRoundOutcomeSelectBoxInstance
            }
          />
          <AddDenialReasonsPopup />
          <RiskAmountAlertPopup />
        </div>
      </ValidationGroup>
    </Resizable>
  );
};
interface ICasePropertiesComponent{
}

const CasePropertiesComponent: React.FC<ICasePropertiesComponent> = (props) => {
  const dispatch = useDispatch();
  const completeCaseDetail = useSelector(
    (state) => state["caseDetailReducer"].completeCaseDetail,
    isEqual
  );
  const auditPropertiesData = useSelector(
    (state: any) => state.auditPropertiesReducer.auditPropertiesData,
    isEqual
  );
  const caseData = useSelector(
    (state) => state["caseDataReducer"].caseData,
    isEqual
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );
  const hasAuditACaseAccess = useMemo(
    () => hasAnyFeatureGroupAccess([FG_AUDIT_A_CASE], currentUser),
    [currentUser]
  );
  const isExternalAuditReadOnly = useSelector(
    (state) => state["auditPropertiesReducer"].isExternalAuditReadOnly,
    isEqual
  );
  const hasEditAccess = hasAuditACaseAccess && !isExternalAuditReadOnly;
  const caseDetailPopupMode = useSelector(
    (state) =>
      state["caseDetailReducer"].caseDetailData.mode
  );

  return (
    <MdaeTabPanel
      id="caseDataTabPanel"
      deferRendering={false}
      onSelectionChanged={(e) => {
        setTimeout(() => {
          if (
            e.addedItems.length &&
            e.addedItems[0]?.title?.toLowerCase() === "case properties"
          ) {
            dispatch({
              type: SET_EXTERNAL_AUDIT_PROPERTIES,
              data: {
                externalAuditProperties: auditPropertiesData,
              },
            });
          }
          if (
            e.addedItems.length &&
            e.addedItems[0]?.title?.toLowerCase() === "case notes"
          ) {
            dispatch({
              type: SET_CASE_FORM_DATA,
              data: {
                caseData: caseData,
              },
            });
          }
        }, 0);
      }}
    >
      {caseDetailPopupMode === CASE_DETAIL_POPUP_MODES.VIEW_WITH_TASK && (
        <Item title="Task">
          <TasksTab />
        </Item>
      )}
      <Item title="Case Properties">
        <CasePropertiesTab mdAuditCaseId={completeCaseDetail?.caseId} />
      </Item>
      <Item title={"Case Notes"}>
        <MdaeTextArea
          style={{ marginRight: 10 }}
          id={"txtCaseNotes"}
          className={"top-margin"}
          height={"350px"}
          readOnly={!hasEditAccess}
          mdaeTextAreaTitle={"Case Notes"}
          mdaeDataUpdaterConfig={[
            {
              actionType: SET_CASE_FORM_DATA,
              reducerName: "caseDataReducer",
              widgetOptionBindings: {
                value: "caseData.caseNotes",
              },
            },
          ]}
        ></MdaeTextArea>
      </Item>
    </MdaeTabPanel>
  );
};

interface ICaseInformationComponent{

}

const CaseInformationComponent: React.FC<ICaseInformationComponent> = () => {
  const dispatch = useDispatch();
  const caseDetailData = useSelector(
    (state) => state["caseDetailReducer"].caseDetailData,
    isEqual
  );
  const [targetType1Instance, setTargetType1Instance] = useState(null);
  const [targetType2Instance, setTargetType2Instance] = useState(null);
  const [isTargetType1Selected, setTargetType1Selected] = useState(false);
  const [
    targetType1CodeValueInstance,
    setTargetType1CodeValueInstance,
  ] = useState(null);
  const [
    targetType2CodeValueInstance,
    setTargetType2CodeValueInstance,
  ] = useState(null);
  const [taregtType1CodeDataSource, setTaregtType1CodeDataSource] = useState(
    []
  );
  const [taregtType2CodeDataSource, setTaregtType2CodeDataSource] = useState(
    []
  );
  const [isRiskAmountAlertShown, setIsRiskAmountAlertShown] = useState(false);
  const caseStatus = useSelector(
    (state) => state["caseDataReducer"].statusList,
    isEqual
  );
  const caseDataValidationMode = useSelector(
    (state) => state["caseDataReducer"].caseDataValidationMode,
    isEqual
  );

  const caseData = useSelector(
    (state) => state["caseDataReducer"].caseData,
    isEqual
  );
  const roundData = useSelector(
    (state) => state["caseDataReducer"].caseData?.roundData,
    isEqual
  );
  const targetTypeLookup = useSelector(
    (state) => state["caseDataReducer"].targetTypes,
    isEqual
  );
  const caseTargetRationaleList = useSelector(
    (state) => state["auditPropertiesReducer"].targetRationaleList
  );
  const targetType2Lookup = useSelector(
    (state) => state["caseDataReducer"].targetTypes2,
    isEqual
  );
  const patientTypes = useSelector(
    (state) => state["caseDataReducer"].patientTypes,
    isEqual
  );

  const isSetTargetCodeValue = useSelector(
    (state) => state["caseDataReducer"].isSetTargetCodeValue,
    isEqual
  );
  const targetType1ValueSource = useSelector(
    (state) => state["caseDataReducer"].targetType1ValueSource,
    isEqual
  );

  const firstRound = first(roundData) as any;
  const totalAtRiskDataSource = [
    firstRound && Array.isArray(firstRound?.roundCharges)
      ? Number(
          firstRound.roundCharges
            .reduce((sum, charge) => sum + Number(charge.atRiskAmnt || 0), 0)
            .toFixed(2)
        )
      : 0,
  ];

  const totalRefundDataSource = [
    firstRound && Array.isArray(firstRound?.roundCharges)
      ? firstRound.roundCharges.reduce(
          (sum, charge) => sum + Number(charge.totalRefundAmnt || 0),
          0
        )
      : 0,
  ];

  const totalRetainedDataSource = [
    firstRound && Array.isArray(firstRound?.roundCharges)
      ? firstRound.roundCharges.reduce(
          (sum, charge) => sum + Number(charge.totalRetainedAmnt || 0),
          0
        )
      : 0,
  ];

  const totalRevenueLossDataSource = [
    firstRound && Array.isArray(firstRound?.roundCharges)
      ? firstRound.roundCharges.reduce(
          (sum, charge) => sum + Number(charge.totalRevenueLoss || 0),
          0
        )
      : 0,
  ];

  useEffect(() => {
    if (roundData?.length > 0)
      dispatch({
        type: SET_CASE_DATA_ACCORDION_SELECTED_KEYS,
        data: {
          keys: roundData?.map((x) => x.eaRoundCaseId) || [],
        },
      });
  }, [roundData?.length, caseData?.eaCaseId]);

  const denialReasonData = useSelector(
    (state: any) => state["caseDataReducer"].denialReasonData,
    isEqual
  );

  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );
  const auditPropertiesData = useSelector(
    (state: any) => state.auditPropertiesReducer.auditPropertiesData,
    isEqual
  );
  const completeCaseDetail = useSelector(
    (state) => state["caseDetailReducer"].completeCaseDetail
  );

  const caseFinalOutcomeValidationCallBack = useMemo(() => {
    return (e) => {
      return caseData?.statusType?.toLowerCase() == "completed" &&
        caseData?.curated?.toLowerCase() == "y" &&
        !e.value
        ? false
        : true;
    };
  }, [caseData?.statusType, caseData?.curated]);

  useEffect(() => {
    dispatch(
      actions.asyncOperationStart(GET_STATUS_LOOKUP_LIST, {
        entity: "EXTERNAL_AUDIT_CASE_STATUS",
      })
    );
    dispatch(
      actions.asyncOperationStart(GET_OUTCOMES_LIST, {
        isShowTermedOutcomes: false,
      })
    );
    callOperation(GET_OUTCOMES_LIST, {}).then(function (response) {
      dispatch({
        type: SET_CASE_FINAL_OUTCOME_LIST_WITH_TERM_DATE,
        data: {
          caseFinalOutcomeListWithTermDate : response.caseFinalOutcomeList,
        },
      });
    });
  }, []);

  useEffect(() => {
    if (caseDetailData?.eaCaseId) {
      getCaseDataTabDataById(dispatch, caseDetailData?.eaCaseId);
    }
    dispatch(
      actions.asyncOperationStart(GET_TARGET_VALUE_LOOKUP, {
        codeType: "DENIAL_REASONS",
        effectiveDate: new Date(),
        groupId:
          auditPropertiesData?.auditGroupId ?? caseDetailData?.auditGroupId,
        eaCaseId: caseDetailData.eaCaseId,
      })
    );
  }, [caseDetailData?.eaCaseId]);

  useEffect(() => {
    if (isSetTargetCodeValue) {
      if (isTargetTypeOfCode(caseData?.caseTargetType1)) {
        targetType1CodeValueInstance?.option(
          "value",
          caseData?.caseTargetValue1
        );
        setTimeout(() => {
          targetType1CodeValueInstance?.repaint();
        });
      }

      if (isTargetTypeOfCode(caseData?.caseTargetType2)) {
        targetType2CodeValueInstance?.option(
          "value",
          caseData?.caseTargetValue2
        );
        setTimeout(() => {
          targetType2CodeValueInstance?.repaint();
        });
      }

      dispatch({ type: SET_IS_SET_TARGET_CODE_VALUES, data: false });
    }
  }, [isSetTargetCodeValue]);

  useEffect(() => {
    return () => {
      dispatch({
        type: SET_ROUND_DATA_SELECTED_TAB,
        data: { roundDataSelectedTab: 0 },
      });
    };
  }, []);

  const ddlTargetType1CodeValueDatasource = useTargetValueDatasource({
    targetType: caseData.caseTargetType1,
    targetTypeLookup,
    serviceFromDate: completeCaseDetail.statementFromDate ?? auditPropertiesData.serviceFromDate,
    serviceToDate: completeCaseDetail.statementToDate ?? auditPropertiesData.serviceToDate,
    auditGroupId: caseData.auditGroupId ?? 0,
    dispatch,
    selectedCodeList: targetType1CodeValueInstance?.option('value'),
    cachedDataSource: caseData?.targetValue1DataSource,
    setLocalDataSource: setTaregtType1CodeDataSource,
    codeValueInstance: targetType1CodeValueInstance,
    existingEntityId: caseData.eaCaseId,
    eaCaseId: caseData.eaCaseId,
    isManualCase: caseDetailData.auditCaseEntryTypeCd === 'MANUAL',
    setPropertiesDataType: SET_CASE_FORM_DATA,
    propertiesDataKey: 'caseData',
    dataSourceKey: 'targetValue1DataSource',
  });
  const ddlTargetType2CodeValueDatasource = useTargetValueDatasource({
    targetType: caseData.caseTargetType2,
    targetTypeLookup: targetType2Lookup,
    serviceFromDate: completeCaseDetail.statementFromDate ?? auditPropertiesData.serviceFromDate,
    serviceToDate: completeCaseDetail.statementToDate ?? auditPropertiesData.serviceToDate,
    auditGroupId: caseData.auditGroupId ?? 0,
    dispatch,
    selectedCodeList: targetType2CodeValueInstance?.option('value') ?? caseData.caseTargetValue2,
    cachedDataSource: caseData?.targetValue2DataSource,
    setLocalDataSource: setTaregtType2CodeDataSource,
    codeValueInstance: targetType2CodeValueInstance,
    existingEntityId: caseData.eaCaseId,
    eaCaseId: caseData.eaCaseId,
    isManualCase: caseDetailData.auditCaseEntryTypeCd === 'MANUAL',
    setPropertiesDataType: SET_CASE_FORM_DATA,
    propertiesDataKey: 'caseData',
    dataSourceKey: 'targetValue2DataSource',
  });

  const hasAuditACaseAccess = useMemo(
    () => hasAnyFeatureGroupAccess([FG_AUDIT_A_CASE], currentUser),
    [currentUser]
  );
  const isExternalAuditReadOnly = useSelector(
    (state) => state["auditPropertiesReducer"].isExternalAuditReadOnly,
    isEqual
  );
  const hasEditAccess = hasAuditACaseAccess && !isExternalAuditReadOnly;

  const isPermOrQioReviewContractor = checkIsPermOrQioReviewContractor(
    caseData?.rqstrRecordSubmissionValue
  );

  const isPayerCaseIdRequired =
    caseData?.rqstrRecordSubmissionMethod?.toLowerCase() === "esmd";

  const isValidPayerCaseId = (e) => {
    if (
      isPayerCaseIdRequired &&
      caseDataValidationMode === caseDataValidationModes.CASE_LEVEL
    ) {
      return verifyPayerCaseId(e.value, caseData?.rqstrRecordSubmissionValue);
    }
    return true;
  };

  const caseFinalOutcomeListWithTermDate = useSelector(
    (state: any) => state["outcomesReducer"].caseFinalOutcomeListWithTermDate,
    isEqual
  );
  const finalCaseFinalOutcomeList = useMemo(() => {
    if (caseFinalOutcomeListWithTermDate?.length > 0) {
      var selectedCaseFinalOutcome = caseFinalOutcomeListWithTermDate?.find(
        (x) => x.eaOutcomeId == caseData?.caseFinalOutcomeId
      );
      var validCaseFinalOutcomeList = caseFinalOutcomeListWithTermDate?.filter(
        (x) =>
          x.termDate
            ? compareDates(x.termDate, new Date()) == 1
              ? true
              : false
            : true
      );
      if (
        caseData?.caseFinalOutcomeId > 0 &&
        !validCaseFinalOutcomeList.find((x) => {
          return x.eaOutcomeId == selectedCaseFinalOutcome?.eaOutcomeId;
        })
      ) {
        selectedCaseFinalOutcome.activeInd = false;
        validCaseFinalOutcomeList.push(selectedCaseFinalOutcome);
        return validCaseFinalOutcomeList;
      } else {
        return validCaseFinalOutcomeList;
      }
    }
  }, [caseFinalOutcomeListWithTermDate, caseData?.caseFinalOutcomeId]);
  const selectBoxHoverText = () => {
    var selectedDenialReson = denialReasonData?.find(
      (x) => x.code == caseData?.denialReasonCode
    );
    return selectedDenialReson?.hoverText;
  };

  const targetValueChangedFunction = useCallback((e) => {
    if (e.value) {
      const widgetName = e.component.option("name");
      dispatch({
        type: SET_CASE_PROPERTIES_DATA,
        data: {
          caseData: { [widgetName]: e.value },
        },
      });
    }
  }, []);
  useEffect(() => {
    if (caseData.caseTargetType1 === "APR_DRG") {
      ddlTargetType1CodeValueDatasource.store.load();
    }
  }, [caseData.caseTargetType1]);
  useEffect(() => {
    if (caseData.caseTargetType2 === "APR_DRG") {
      ddlTargetType2CodeValueDatasource.store.load();
    }
  }, [caseData.caseTargetType2]);
  useEffect(() => {
    if (
      (!caseData.statusId || caseData.statusId === 0) &&
      Array.isArray(caseStatus) &&
      caseStatus.length > 0
    ) {
      const defaultStatus = caseStatus.find((x) => x.defaultInd === "Y");
      if (defaultStatus) {
        dispatch({
          type: SET_CASE_FORM_DATA,
          data: {
            caseData: {
              ...caseData,
              statusId: defaultStatus.statusId,
              statusName: defaultStatus.displayAlias,
              statusType: defaultStatus.statusType,
              curated: defaultStatus.curated,
            },
          },
        });
      }
    }
  }, [caseData.statusId, caseStatus, dispatch]);
  const handleAtRiskValueKeyDown = useCallback(() => {
    if (auditPropertiesData.isAtRiskPayerEnabled && !isRiskAmountAlertShown) {
      dispatch({
        type: SET_RISK_AMOUNT_ALERT_STATUS,
        data: {
          visible: true,
        },
      });
      setIsRiskAmountAlertShown(true);
    }
  }, [
    auditPropertiesData.isAtRiskPayerEnabled,
    isRiskAmountAlertShown,
    dispatch,
  ]);
  const dataSourceForPayerCaseId = useMemo(() => {
    return [
      {
        id: caseData.payerRemitNo,
        payerRemitNo: caseData.payerRemitNo,
      },
    ];
  }, [caseData.payerRemitNo]);

  const payerCaseIdTitle = useMemo(() => {
    return isPermOrQioReviewContractor ? "Payer Case ID" : "Payer Claim ID";
  }, [isPermOrQioReviewContractor]);

  const payerCaseIdElementAttr = useMemo(() => {
    return {
      title: isPermOrQioReviewContractor
        ? "11 Alphanumeric characters (A-Z, 0-9)"
        : "8 digits, or 13 to 15 digits, or 17-23 alphanumeric characters (A-Z, a-z, 0-9, dash or space)",
    };
  }, [isPermOrQioReviewContractor]);

  const payerCaseIdValidator = useMemo(
    () => (
      <Validator validationGroup={caseDataValidationGroup}>
        <CustomRule
          reevaluate={true}
          validationCallback={isValidPayerCaseId}
          message={`Please enter valid payer ${
            isPermOrQioReviewContractor ? "case" : "claim"
          } id`}
        />
      </Validator>
    ),
    [isPermOrQioReviewContractor, isValidPayerCaseId]
  );

  const onPayerCaseIdChangeHandler = useCallback(
    (value: string) => {
      dispatch({
        type: SET_CASE_FORM_DATA,
        data: { caseData: { payerCaseId: value } },
      });
    },
    [dispatch]
  );

  const closeConfirmationPopup = () => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        visible: false,
        title: "Confirmation",
      },
    });
  };

  return (
    <>
      <div className={"case-data-field-flex top-margin"}>
        <div className={"case-data-field-col1"}>
          {caseData.payerRemitNo ? (
            <MdaeAutoComplete
              id="txtPayerCaseId"
              dataSource={dataSourceForPayerCaseId}
              value={caseData.payerCaseId}
              displayExpr="payerRemitNo"
              valueExpr="payerRemitNo"
              acceptCustomValue={true}
              showDropDownButton={true}
              onCustomItemCreating={(e) => {
                e.customItem = { payerRemitNo: e.text };
              }}
              openOnFieldClick={true}
              searchEnabled={false}
              mdaeAutocompleteTitle={payerCaseIdTitle}
              maxLength={100}
              deferRendering={false}
              required={isPayerCaseIdRequired}
              readOnly={!hasEditAccess}
              elementAttr={payerCaseIdElementAttr}
              minSearchLength={0}
              onValueChange={onPayerCaseIdChangeHandler}
            >
              {payerCaseIdValidator}
            </MdaeAutoComplete>
          ) : (
            <MdaeTextBox
              id="txtPayerCaseId"
              required={isPayerCaseIdRequired}
              mdaeTextBoxTitle={payerCaseIdTitle}
              maxLength={100}
              readOnly={!hasEditAccess}
              elementAttr={payerCaseIdElementAttr}
              mdaeDataUpdaterConfig={[
                {
                  actionType: SET_CASE_FORM_DATA,
                  reducerName: "caseDataReducer",
                  widgetOptionBindings: {
                    value: "caseData.payerCaseId",
                  },
                },
              ]}
            >
              {payerCaseIdValidator}
            </MdaeTextBox>
          )}
        </div>
        <div className={"case-data-field-col2"}></div>
        <div className={"case-data-field-col3"}>
          <div className={"case-data-field-container"}>
            <div className={"case-data-field1"}>
              <MdaeAutoComplete
                id="txtAtRisk"
                MdaeAutocompleteTitleComponentClassName={
                  "mdae-text-box-field-with-dollar-icon-set-text"
                }
                MdaeAutocompleteTitleComponent={
                  hasEditAccess && caseDetailData.historyCount > 0
                    ? () => {
                        return (
                          <PullTotalChargeAmountButton
                            caseDetailData={caseDetailData}
                            dispatch={dispatch}
                            toggleBillHistoryPopupVisible={
                              toggleBillHistoryPopupVisible
                            }
                            varToUpdate="atRisk"
                          />
                        );
                      }
                    : null
                }
                mdaeAutocompleteTitle="At Risk $"
                dataSource={totalAtRiskDataSource.map((v) => ({
                  value: v,
                  label: formatCurrency(v),
                }))}
                displayExpr="label"
                valueExpr="value"
                value={formatCurrency(caseData.atRiskAmnt)}
                onInput={normalizeCurrencyInput}
                acceptCustomValue={true}
                openOnFieldClick={true}
                minSearchLength={0}
                required={caseData.atRiskAmnt == null}
                readOnly={!hasEditAccess}
                onKeyDown={handleAtRiskValueKeyDown}
                searchEnabled={false} // disables filtering, always shows all options
                onValueChanged={(e) => {
                  const raw = parseNumber(e.value);
                  dispatch({
                    type: SET_CASE_FORM_DATA,
                    data: { caseData: { atRiskAmnt: raw } },
                  });
                }}
              >
                <Validator
                  validationGroup={caseDataValidationGroup}
                  name="atRiskAmntValidator"
                >
                  <RequiredRule message="At Risk $ is Required" />
                </Validator>
              </MdaeAutoComplete>
            </div>
            <div className={"case-data-field2"}>
              <MdaeNumericBox
                id={"txtRemainingInReview"}
                mdaeNumberBoxTitle={"Remaining $ in Review"}
                readOnly
                value={
                  parseFloat(
                    (
                      (caseData?.atRiskAmnt || 0) -
                      (caseData?.totalRetainedAmnt || 0) -
                      (caseData?.totalRefundAmnt || 0) -
                      (caseData?.totalRevenueLoss || 0)
                    ).toFixed(2)
                  ) || 0
                }
                format={"$ #,##0.##"}
                min={0}
                max={999999.0}
                showSpinButtons={false}
                mdaeDataUpdaterConfig={[
                  {
                    actionType: SET_CASE_FORM_DATA,
                    reducerName: "caseDataReducer",
                    widgetOptionBindings: {
                      value: "caseData.reviewRemainingAmnt",
                    },
                  },
                ]}
              ></MdaeNumericBox>
            </div>

            <div className={"case-data-field3"}>
              <MdaeNumericBox
                id={"txtAdditionalReimbursementAmnt"}
                mdaeNumberBoxTitle={"Additional Reimbursement $"}
                format={"$ #,##0.##"}
                min={0}
                max={999999.0}
                readOnly={!hasEditAccess}
                showSpinButtons={false}
                mdaeDataUpdaterConfig={[
                  {
                    actionType: SET_CASE_FORM_DATA,
                    reducerName: "caseDataReducer",
                    widgetOptionBindings: {
                      value: "caseData.additionalReimbursementAmnt",
                    },
                  },
                ]}
              ></MdaeNumericBox>
            </div>

          </div>
        </div>
      </div>
      <div className={"case-data-field-flex top-margin"}>
        <div className={"case-data-field-col1"}>
          <MdaeSelectBox
            id={"ddlStatus"}
            mdaeDropDownBoxTitle={"Status"}
            displayExpr={"displayAlias"}
            valueExpr={"statusId"}
            dataSource={caseStatus || []}
            required
            readOnly={!hasEditAccess}
            onValueChanged={(e) => {
              const selectedStatus = e.component.option("selectedItem");
              const previousStatusId = e.previousValue;
              const previousStatusType = caseStatus?.find((s) => s.statusId === previousStatusId)?.statusType;

              if (e.event && selectedStatus?.statusType?.toLowerCase() === "completed" && previousStatusType?.toLowerCase() !== "completed") {

                const checkDocuments = () => {
                  callOperation(GET_DOCUMENTS, {
                    attachedLevelId: caseData.eaCaseId,
                    attachedLevelName: "EAC",
                    showForCoderReviewInd: false,
                  }).then((response) => {
                    const documentCount = response?.data?.documentList?.length || 0;

                    if (documentCount === 0) {
                      dispatch({
                        type: TOGGLE_CONFIRMATION_POPUP,
                        data: {
                          visible: true,
                          width: 450,
                          height: 200,
                          contentHtml: "This case has no documents uploaded into Document Management. Continue?",
                          title: "Alert: No Documents Uploaded",
                          declineShown: true,
                          confirmShown: true,
                          declineLabel: "Cancel",
                          confirmLabel: "Continue",
                          onConfirm: () => {
                            closeConfirmationPopup();
                            setTimeout(() => {
                              dispatch({
                                type: SET_CASE_FORM_DATA,
                                data: {
                                  caseData: {
                                    statusName: selectedStatus?.displayAlias,
                                    statusType: selectedStatus?.statusType,
                                    curated: selectedStatus?.curated,
                                  },
                                },
                              });
                            }, 100);
                          },
                          onDecline: () => {
                            closeConfirmationPopup();
                            e.component.option("value", previousStatusId);
                          },
                        },
                      });
                    } else {
                      setTimeout(() => {
                        dispatch({
                          type: SET_CASE_FORM_DATA,
                          data: {
                            caseData: {
                              statusName: selectedStatus?.displayAlias,
                              statusType: selectedStatus?.statusType,
                              curated: selectedStatus?.curated,
                            },
                          },
                        });
                      }, 100);
                    }
                  });
                };

                const checkOpenTasks = () => {
                  callOperation(GET_USER_TASK_LIST_BY_LEVEL, {
                    attachedLevelId: caseData.eaCaseId,
                    attachedLevelName: "EAC",
                    includeNonAttachedLevelTasks: false,
                  }).then((response) => {
                    const freshTaskList = response?.userTaskList || [];
                    const openTasks = freshTaskList.filter(
                      (task) =>
                        task.statusType?.toLowerCase() !== "completed" &&
                        task.statusType?.toLowerCase() !== "canceled"
                    );

                    if (openTasks.length > 0) {
                      dispatch({
                        type: TOGGLE_CONFIRMATION_POPUP,
                        data: {
                          visible: true,
                          width: 380,
                          height: 200,
                          contentHtml: "This case still has open tasks. Continue?",
                          title: "Alert: Open Tasks",
                          declineShown: true,
                          confirmShown: true,
                          declineLabel: "Cancel",
                          confirmLabel: "Continue",
                          onConfirm: () => {
                            closeConfirmationPopup();
                            checkDocuments();
                          },
                          onDecline: () => {
                            closeConfirmationPopup();
                            e.component.option("value", previousStatusId);
                          },
                        },
                      });
                    } else {
                      checkDocuments();
                    }
                  });
                };

                checkOpenTasks();
              } else {
                setTimeout(() => {
                  dispatch({
                    type: SET_CASE_FORM_DATA,
                    data: {
                      caseData: {
                        statusName: selectedStatus?.displayAlias,
                        statusType: selectedStatus?.statusType,
                        curated: selectedStatus?.curated,
                      },
                    },
                  });
                }, 100);
              }
            }}
            mdaeDataUpdaterConfig={[
              {
                actionType: SET_CASE_FORM_DATA,
                reducerName: "caseDataReducer",
                widgetOptionBindings: {
                  value: "caseData.statusId",
                },
              },
            ]}
          >
            <Validator
              validationGroup={caseDataValidationGroup}
              name="caseStatusValidator"
            >
              <RequiredRule message={"Case Status is Required"} />
            </Validator>
          </MdaeSelectBox>
        </div>
        <div className={"case-data-field-col2"}></div>
        <div className={"case-data-field-col3"}>
          <div className={"case-data-field-container"}>
            <div className={"case-data-field1"}>
              <MdaeAutoComplete
                id={"txtTotalRetainedAmnt"}
                mdaeAutocompleteTitle={"Total Retained $"}
                MdaeAutocompleteTitleComponentClassName={
                  "mdae-text-box-field-with-dollar-icon-set-text"
                }
                MdaeAutocompleteTitleComponent={
                  hasEditAccess && caseDetailData.historyCount > 0
                    ? () => {
                        return (
                          <PullTotalChargeAmountButton
                            caseDetailData={caseDetailData}
                            dispatch={dispatch}
                            toggleBillHistoryPopupVisible={
                              toggleBillHistoryPopupVisible
                            }
                            varToUpdate="totalRetained"
                          />
                        );
                      }
                    : null
                }
                readOnly={!hasEditAccess}
                dataSource={totalRetainedDataSource.map((v) => ({
                  value: v,
                  label: formatCurrency(v),
                }))}
                displayExpr="label"
                valueExpr="value"
                value={formatCurrency(caseData.totalRetainedAmnt)}
                onInput={normalizeCurrencyInput}
                acceptCustomValue={true}
                openOnFieldClick={true}
                minSearchLength={0}
                searchEnabled={false} // disables filtering, always shows all options
                onValueChanged={(e) => {
                  const raw = parseNumber(e.value);
                  dispatch({
                    type: SET_CASE_FORM_DATA,
                    data: {
                      caseData: { totalRetainedAmnt: raw },
                    },
                  });
                }}
              ></MdaeAutoComplete>
            </div>
            <div className={"case-data-field2"}>
              <MdaeAutoComplete
                id={"txtTotalRefundAmnt"}
                mdaeAutocompleteTitle={"Total Refund $"}
                MdaeAutocompleteTitleComponentClassName={
                  "mdae-text-box-field-with-dollar-icon-set-text"
                }
                MdaeAutocompleteTitleComponent={
                  hasEditAccess && caseDetailData.historyCount > 0
                    ? () => {
                        return (
                          <PullTotalChargeAmountButton
                            caseDetailData={caseDetailData}
                            dispatch={dispatch}
                            toggleBillHistoryPopupVisible={
                              toggleBillHistoryPopupVisible
                            }
                            varToUpdate="totalRefund"
                          />
                        );
                      }
                    : null
                }
                readOnly={!hasEditAccess}
                dataSource={totalRefundDataSource.map((v) => ({
                  value: v,
                  label: formatCurrency(v),
                }))}
                displayExpr="label"
                valueExpr="value"
                value={formatCurrency(caseData.totalRefundAmnt)}
                onInput={normalizeCurrencyInput}
                acceptCustomValue={true}
                openOnFieldClick={true}
                minSearchLength={0}
                searchEnabled={false} // disables filtering, always shows all options
                onValueChanged={(e) => {
                  const raw = parseNumber(e.value);
                  dispatch({
                    type: SET_CASE_FORM_DATA,
                    data: { caseData: { totalRefundAmnt: raw } },
                  });
                }}
              ></MdaeAutoComplete>
            </div>
            <div className={"case-data-field3"}>
              <MdaeAutoComplete
                id={"txtTotalRevenueLoss"}
                mdaeAutocompleteTitle={"Revenue Loss $"}
                MdaeAutocompleteTitleComponentClassName={
                  "mdae-text-box-field-with-dollar-icon-set-text"
                }
                MdaeAutocompleteTitleComponent={
                  hasEditAccess && caseDetailData.historyCount > 0
                    ? () => (
                        <PullTotalChargeAmountButton
                          caseDetailData={caseDetailData}
                          dispatch={dispatch}
                          toggleBillHistoryPopupVisible={toggleBillHistoryPopupVisible}
                          varToUpdate="totalRevenueLoss"
                        />
                      )
                    : null
                }
                readOnly={!hasEditAccess}
                dataSource={totalRevenueLossDataSource.map((v) => ({
                  value: v,
                  label: formatCurrency(v),
                }))}
                displayExpr="label"
                valueExpr="value"
                value={formatCurrency(caseData.totalRevenueLoss || 0)}
                onInput={normalizeCurrencyInput}
                acceptCustomValue={true}
                openOnFieldClick={true}
                minSearchLength={0}
                searchEnabled={false}
                onValueChanged={(e) => {
                  const raw = parseNumber(e.value);
                  dispatch({
                    type: SET_CASE_FORM_DATA,
                    data: { caseData: { totalRevenueLoss: raw } },
                  });
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={"case-data-field-flex top-margin"}>
        <div className={"case-data-field-col1"}>
          <MdaeSelectBox
            id={"ddlCaseFinalOutcome"}
            mdaeDropDownBoxTitle={"Case Final Outcome"}
            displayExpr={"eaOutcomeName"}
            valueExpr={"eaOutcomeId"}
            elementAttr={{
              title: !caseData.roundData[0]?.roundOutcomeId
                ? "Case Final Outcome cannot be added without a current round outcome"
                : caseData.roundData[0].roundOutcomeType?.toLowerCase() ===
                  "dwa"
                ? "Case Final Outcome cannot be added to cases that will be appealed. "
                : "",
            }}
            required={
              caseData?.statusType?.toLowerCase() == "completed" &&
              caseData?.curated?.toLowerCase() == "y"
                ? true
                : false
            }
            readOnly={
              !hasEditAccess ||
              !caseData.roundData[0]?.roundOutcomeId ||
              caseData.roundData[0].roundOutcomeType?.toLowerCase() === "dwa"
            }
            onItemClick={(e) => {
              setTimeout(() => {
                dispatch({
                  type: SET_CASE_FORM_DATA,
                  data: {
                    caseData: {
                      caseFinalOutcomeName: e.component.option("selectedItem")
                        ?.eaOutcomeName,
                      moveInProgressDollarToType: e.component.option(
                        "selectedItem"
                      )?.moveInProgressDollarToType,
                    },
                  },
                });
              }, 100);
            }}
            dataSource={finalCaseFinalOutcomeList || []}
            itemRender={(e) => {
              if (e.activeInd !== false) {
                return <div>{e.eaOutcomeName}</div>;
              }
            }}
            mdaeDataUpdaterConfig={[
              {
                actionType: SET_CASE_FORM_DATA,
                reducerName: "caseDataReducer",
                widgetOptionBindings: {
                  value: "caseData.caseFinalOutcomeId",
                },
              },
            ]}
          >
            <Validator validationGroup={caseDataValidationGroup}>
              <CustomRule
                message="Case Final Outcome is required"
                validationCallback={caseFinalOutcomeValidationCallBack}
              />
            </Validator>
          </MdaeSelectBox>
        </div>
        <div className={"case-data-field-col2"}></div>
        <div className={"case-data-field-col3"}>
          <div className={"case-data-field-container"}>
            <div className={"denial-reason-drop-down"}>
              <div className={"denial-reason-drop-down-elements"}>
                <MdaeSelectBox
                  id={"ddlDenialReason"}
                  mdaeDropDownBoxTitle={"Denial Reason"}
                  displayExpr={"denialReasonName"}
                  valueExpr={"code"}
                  elementAttr={{
                    title: selectBoxHoverText(),
                  }}
                  searchExpr={["denialReasonName", "code"]}
                  readOnly={!hasEditAccess}
                  itemRender={(e) => {
                    return <div title={e.hoverText}>{e.denialReasonName}</div>;
                  }}
                  onItemClick={(e) => {
                    setTimeout(() => {
                      dispatch({
                        type: SET_CASE_FORM_DATA,
                        data: {
                          caseData: {
                            denialReasonName: e.component.option("selectedItem")
                              ?.denialReasonName,
                          },
                        },
                      });
                    }, 100);
                  }}
                  dataSource={denialReasonData || []}
                  mdaeDataUpdaterConfig={[
                    {
                      actionType: SET_CASE_FORM_DATA,
                      reducerName: "caseDataReducer",
                      widgetOptionBindings: {
                        value: "caseData.denialReasonCode",
                      },
                    },
                  ]}
                ></MdaeSelectBox>
              </div>
              <div>
                <MdaeButton
                  id={"btnAddNewDenialReason"}
                  role={"dxButton"}
                  icon="fa fa-plus application-section-primary-color"
                  text={""}
                  hint={"Add Denial Reason"}
                  onClick={() => {
                    toggleDenialReasonsPopup(dispatch, true);
                  }}
                ></MdaeButton>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={"case-data-field-flex top-margin"}>
        <div className={"case-data-field-col1"}>
          <MdaeTextBox
            id={"txtPreviousRoundOutcome"}
            readOnly
            mdaeTextBoxTitle={"Previous Round Outcome"}
            value={caseData?.previousRoundOutcome}
          ></MdaeTextBox>
        </div>
        <div className={"case-data-field-col2"}></div>
        <div className={"case-data-field-col3"}>
          <div className={"case-data-field-container"}>
            <div className={"case-data-field1"}>
              <MdaeDateBox
                id="dtRefundSubmittedDate"
                mdaeDateBoxTitle="Refund Submitted Date"
                type="date"
                disabled={!caseData.manualRefundRequired}
                readOnly={!hasEditAccess}
                mdaeDataUpdaterConfig={[
                  {
                    actionType: SET_CASE_FORM_DATA,
                    reducerName: "caseDataReducer",
                    widgetOptionBindings: {
                      value: "caseData.refundSubmittedDate",
                    },
                  },
                ]}
              ></MdaeDateBox>
            </div>
            <div className={"case-data-field2"}>
              <MdaeDateBox
                id="dtRefundCompletedDate"
                mdaeDateBoxTitle="Refund Completed Date"
                type="date"
                readOnly={!hasEditAccess}
                mdaeDataUpdaterConfig={[
                  {
                    actionType: SET_CASE_FORM_DATA,
                    reducerName: "caseDataReducer",
                    widgetOptionBindings: {
                      value: "caseData.refundCompletedDate",
                    },
                  },
                ]}
              ></MdaeDateBox>
            </div>
            <div className={"case-data-field3 manual-refund-required"}>
              <MdaeCheckBox
                id={"chkManualRefundRequired"}
                text={"Manual refund required"}
                readOnly={!hasEditAccess}
                mdaeDataUpdaterConfig={[
                  {
                    actionType: SET_CASE_FORM_DATA,
                    reducerName: "caseDataReducer",
                    widgetOptionBindings: {
                      value: "caseData.manualRefundRequired",
                    },
                  },
                ]}
              ></MdaeCheckBox>
            </div>
          </div>
        </div>
      </div>
      <div className={"widget-separation-margin-top"}>
        <MdaeTagBox
          id={"ddlcaseTargetRationaleValue"}
          mdaeTagBoxTitle={"Case Target Rationale"}
          style={{ height: "40px", width: "470px" }}
          displayExpr={"name"}
          dataSource={sortSelectedItemsOnTop(
            caseTargetRationaleList,
            caseData.caseTargetRationaleValue
          )}
          valueExpr={"value"}
          searchEnabled={true}
          showSelectionControls={true}
          maxDisplayedTags={1}
          value={(caseData.caseTargetRationaleValue || []).map(Number)}
          onValueChanged={(e) => {
            if (e.event) {
              const value = (e.value || []).map(Number);
              dispatch({
                type: SET_CASE_PROPERTIES_DATA,
                data: {
                  caseData: {
                    caseTargetRationaleValue: value,
                  },
                },
              });
            }
          }}
        ></MdaeTagBox>
      </div>
      <div className={"case-data-field-flex"} style={{ marginTop: 10 }}>
        <div className={"widget-separation-margin-top"}>
          <MdaeSelectBox
            id={"ddlCaseTargetType"}
            style={{ width: "470px" }}
            onInitialized={(e) => {
              setTargetType1Instance(e.component);
            }}
            mdaeDropDownBoxTitle={"Case Target Type 1"}
            displayExpr={"displayName"}
            valueExpr={"value"}
            dataSource={targetTypeLookup || []}
            value={caseData.caseTargetType1}
            onValueChanged={(e) => {
              if (e.value) {
                setTargetType1Selected(true);
                let filtereditem =
                  targetTypeLookup &&
                  targetTypeLookup.filter((x) => x.value === e.value);
                let codeTypeValue = filtereditem[0]?.codeType;
                if (codeTypeValue && codeTypeValue?.toLowerCase() !== "pt") {
                } else {
                  dispatch({
                    type: SET_TARGET_TYPE_VALUE_DATA_SOURCE,
                    targetType1ValueSource: patientTypes,
                    currentTagetType: 1,
                    codeTypeValue: codeTypeValue,
                  });
                }
              } else {
                setTargetType1Selected(false);
              }
              if (e.event) {
                dispatch({
                  type: SET_CASE_PROPERTIES_DATA,
                  data: {
                    caseData: {
                      caseTargetType1: e.value,
                      caseTargetValue1: null,
                    },
                  },
                });
              }
            }}
          >
            <Validator validationGroup={caseDataValidationGroup} />
          </MdaeSelectBox>
        </div>
        {caseData?.caseTargetType1 !== "OTHER" &&
          caseData?.caseTargetType1 !== "PT" && (
            <div
              className="widget-separation-margin-top"
              style={{ marginLeft: "55px" }}
            >
              {targetType1Instance?.option("selectedItem")?.codeType ==
                "APR_DRG" && taregtType1CodeDataSource?.length == 0 ? (
                <MdaeTextArea
                  id="txtCaseTargetValue"
                  mdaeTextAreaTitle="Case Target Value 1"
                  style={{ height: "40px", width: "435px" }}
                  maxLength={200}
                  value={caseData.caseTargetValue1}
                  name="caseTargetValue1"
                  onValueChanged={targetValueChangedFunction}
                >
                  <Validator validationGroup={caseDataValidationGroup}>
                    <PatternRule
                      message="Only numbers and commas are allowed"
                      pattern={/^[0-9,]*$/}
                    ></PatternRule>
                  </Validator>
                </MdaeTextArea>
              ) : (
                <>
                  {caseData?.caseTargetType1 !== "OTHER" &&
                    caseData?.caseTargetType1 !== "PT" && (
                      <MdaeTagBox
                        id={"ddlCaseTargetValue1"}
                        mdaeTagBoxTitle={"Case Target Value 1"}
                        style={{ height: "40px", width: "435px" }}
                        displayExpr={
                          targetType1Instance?.option("selectedItem")
                            ?.codeType == "APR_DRG"
                            ? "code"
                            : "description"
                        }
                        valueExpr={"code"}
                        onInitialized={(e) => {
                          setTargetType1CodeValueInstance(e.component);
                        }}
                        searchEnabled={true}
                        showSelectionControls={true}
                        maxDisplayedTags={1}
                        value={caseData.caseTargetValue1 || []}
                        onValueChanged={(e) => {
                          const codeType = targetType1Instance?.option(
                            "selectedItem"
                          )?.codeType;
                          var values = e.component.option("value");
                          if (values && values.length && codeType) {
                            const notLoadedValues = [];
                            for (let i = 0; i < values.length; i++) {
                              var item = taregtType1CodeDataSource.find(
                                (x) => x.code === values[i]
                              );
                              if (!(item && item.code)) {
                                notLoadedValues.push(values[i]);
                              }
                            }
                            if (notLoadedValues.length > 0) {
                              callOperation(GET_EA_TARGET_VALUE_SOURCES, {
                                CodeType: codeType,
                                CodeList: notLoadedValues,
                                fromServiceDate: new Date(
                                  completeCaseDetail.statementFromDate ??
                                    auditPropertiesData.serviceFromDate
                                ),
                                toServiceDate: new Date(
                                  completeCaseDetail.statementToDate ??
                                    auditPropertiesData.serviceToDate
                                ),
                              }).then((result) => {
                                setTaregtType1CodeDataSource(result);
                              });
                            }
                          }
                          if (e.value) {
                            dispatch({
                              type: SET_CASE_PROPERTIES_DATA,
                              data: {
                                caseData: {
                                  caseTargetValue1: e.value,
                                },
                              },
                            });
                          }
                        }}
                        dataSource={ddlTargetType1CodeValueDatasource}
                      >
                        <Validator validationGroup={caseDataValidationGroup} />
                      </MdaeTagBox>
                    )}
                </>
              )}
            </div>
          )}
        {caseData?.caseTargetType1 === "OTHER" && (
          <div
            className="widget-separation-margin-top"
            style={{ marginLeft: "55px" }}
          >
            <MdaeTextArea
              id="txtCaseTargetValue"
              mdaeTextAreaTitle="Case Target Value 1"
              style={{ height: "40px", width: "435px" }}
              maxLength={200}
              value={caseData.caseTargetValue1}
              name="caseTargetValue1"
              onValueChanged={targetValueChangedFunction}
            >
              <Validator validationGroup={caseDataValidationGroup}>
                <CustomRule
                  message={invalidOrUnprintableCharMassage}
                  reevaluate
                  validationCallback={(params) =>
                    isPrintableAscii(params.value)
                  }
                />
              </Validator>
            </MdaeTextArea>
          </div>
        )}

        {caseData?.caseTargetType1 === "PT" && (
          <div
            className="widget-separation-margin-top"
            style={{ marginLeft: "55px" }}
          >
            <MdaeSelectBox
              id={"ddlCaseTargetValue1"}
              mdaeDropDownBoxTitle={"Case Target value 1"}
              displayExpr={"description"}
              valueExpr={"code"}
              style={{ height: "40px", width: "435px" }}
              dataSource={targetType1ValueSource || []}
              value={caseData.caseTargetValue1}
              onValueChanged={(e) => {
                if (e.value) {
                  dispatch({
                    type: SET_CASE_PROPERTIES_DATA,
                    data: {
                      caseData: { caseTargetValue1: e.value },
                    },
                  });
                }
              }}
            >
              <Validator validationGroup={caseDataValidationGroup} />
            </MdaeSelectBox>
          </div>
        )}
      </div>
      <div className={"case-data-field-flex"} style={{ marginTop: 10 }}>
        {isTargetType1Selected && (
          <div className="widget-separation-margin-top">
            <MdaeSelectBox
              id={"ddlCaseTargetType2"}
              mdaeDropDownBoxTitle={"Case Target Type 2"}
              style={{ width: "470px" }}
              onInitialized={(e) => {
                setTargetType2Instance(e.component);
              }}
              displayExpr={"displayName"}
              valueExpr={"value"}
              dataSource={targetType2Lookup || []}
              value={caseData.caseTargetType2}
              onOpened={(e) => {
                if (targetType1Instance?.option("value")) {
                  let filteredItems =
                    targetTypeLookup &&
                    targetTypeLookup.filter(
                      (x) => x.value != targetType1Instance?.option("value")
                    );
                  dispatch({
                    type: SET_TARGET_TYPES_LOOKUP,
                    targetTypes2: filteredItems,
                    currentTagetType: 2,
                  });
                }
              }}
              onValueChanged={(e) => {
                if (e.value) {
                  let filtereditem =
                    targetType2Lookup &&
                    targetType2Lookup.filter((x) => x.value === e.value);
                  let codeTypeValue = filtereditem[0]?.codeType;
                  if (codeTypeValue && codeTypeValue.toLowerCase() !== "pt") {
                  } else {
                    dispatch({
                      type: SET_TARGET_TYPE_VALUE_DATA_SOURCE,
                      targetType2ValueSource: patientTypes,
                      currentTargetType: 2,
                      codeTypeValue: codeTypeValue,
                    });
                  }
                }
                if (e.event) {
                  dispatch({
                    type: SET_CASE_PROPERTIES_DATA,
                    data: {
                      caseData: {
                        caseTargetType2: e.value,
                        caseTargetValue2: null,
                      },
                    },
                  });
                }
              }}
            >
              <Validator validationGroup={caseDataValidationGroup} />
            </MdaeSelectBox>
          </div>
        )}
        {caseData?.caseTargetType2 !== "OTHER" &&
          caseData?.caseTargetType2 !== "PT" &&
          isTargetType1Selected && (
            <div
              className="widget-separation-margin-top"
              style={{ marginLeft: "55px" }}
            >
              {targetType2Instance?.option("selectedItem")?.codeType ==
                "APR_DRG" && taregtType2CodeDataSource?.length == 0 ? (
                <MdaeTextArea
                  id="txtCaseTargetValue2"
                  mdaeTextAreaTitle="Case Target Value 2"
                  style={{ height: "40px", width: "435px" }}
                  maxLength={200}
                  value={caseData.caseTargetValue2}
                  name="caseTargetValue2"
                  onValueChanged={targetValueChangedFunction}
                >
                  <Validator validationGroup={caseDataValidationGroup}>
                    <PatternRule
                      message="Only numbers and commas are allowed"
                      pattern={/^[0-9,]*$/}
                    ></PatternRule>
                  </Validator>
                </MdaeTextArea>
              ) : (
                <>
                  {caseData?.caseTargetType2 !== "OTHER" &&
                    caseData?.caseTargetType2 !== "PT" && (
                      <MdaeTagBox
                        id={"ddlCaseTargetValue2"}
                        mdaeTagBoxTitle={"Case Target value 2"}
                        style={{ height: "40px", width: "435px" }}
                        displayExpr={
                          targetType2Instance?.option("selectedItem")
                            ?.codeType == "APR_DRG"
                            ? "code"
                            : "description"
                        }
                        valueExpr={"code"}
                        onInitialized={(e) => {
                          setTargetType2CodeValueInstance(e.component);
                        }}
                        value={caseData.caseTargetValue2 || []}
                        onValueChanged={(e) => {
                          const codeType = targetType2Instance?.option(
                            "selectedItem"
                          )?.codeType;
                          var values = e.component.option("value");
                          if (values && values.length && codeType) {
                            const notLoadedValues = [];
                            for (let i = 0; i < values.length; i++) {
                              var item = taregtType2CodeDataSource.find(
                                (x) => x.code === values[i]
                              );
                              if (!(item && item.code)) {
                                notLoadedValues.push(values[i]);
                              }
                            }
                            if (notLoadedValues.length > 0) {
                              callOperation(GET_EA_TARGET_VALUE_SOURCES, {
                                CodeType: codeType,
                                CodeList: notLoadedValues,
                                fromServiceDate: new Date(
                                  completeCaseDetail.statementFromDate ??
                                    auditPropertiesData.serviceFromDate
                                ),
                                toServiceDate: new Date(
                                  completeCaseDetail.statementToDate ??
                                    auditPropertiesData.serviceToDate
                                ),
                              }).then((result) => {
                                setTaregtType2CodeDataSource(result);
                              });
                            }
                          }
                          if (e.value) {
                            dispatch({
                              type: SET_CASE_PROPERTIES_DATA,
                              data: {
                                caseData: {
                                  caseTargetValue2: e.value,
                                },
                              },
                            });
                          }
                        }}
                        showSelectionControls={true}
                        maxDisplayedTags={1}
                        dataSource={ddlTargetType2CodeValueDatasource}
                      >
                        <Validator validationGroup={caseDataValidationGroup} />
                      </MdaeTagBox>
                    )}
                </>
              )}
            </div>
          )}

        {caseData?.caseTargetType2 === "OTHER" && isTargetType1Selected && (
          <div
            className="widget-separation-margin-top"
            style={{ marginLeft: "55px" }}
          >
            <MdaeTextArea
              id="txtCaseTargetValue2"
              mdaeTextAreaTitle="Case Target Value 2"
              style={{ height: "40px", width: "435px" }}
              maxLength={200}
              value={caseData.caseTargetValue2}
              name="caseTargetValue2"
              onValueChanged={targetValueChangedFunction}
            >
              <Validator validationGroup={caseDataValidationGroup}>
                <CustomRule
                  message={invalidOrUnprintableCharMassage}
                  reevaluate
                  validationCallback={(params) =>
                    isPrintableAscii(params.value)
                  }
                />
              </Validator>
            </MdaeTextArea>
          </div>
        )}
        {caseData?.caseTargetType2 === "PT" &&
          isTargetType1Selected &&
          caseData?.caseTargetType2 !== "OTHER" && (
            <div
              className="widget-separation-margin-top"
              style={{ marginLeft: "55px" }}
            >
              <MdaeSelectBox
                id={"ddlCaseTargetValue2"}
                mdaeDropDownBoxTitle={"Case Target Value 2"}
                displayExpr={"description"}
                valueExpr={"code"}
                style={{ height: "40px", width: "435px" }}
                dataSource={targetType1ValueSource || []}
                value={caseData.caseTargetValue2}
                onValueChanged={(e) => {
                  if (e.value) {
                    dispatch({
                      type: SET_CASE_PROPERTIES_DATA,
                      data: {
                        caseData: { caseTargetValue2: e.value },
                      },
                    });
                  }
                }}
              >
                <Validator validationGroup={caseDataValidationGroup} />
              </MdaeSelectBox>
            </div>
          )}
      </div>
    </>
  );
};

const isSelectedOutcomeOfTypeWillNotAppeal = (
  allOutcomeListObj: any[],
  eaOutcomeId: number
) => {
  const outcomeObjToCheck = allOutcomeListObj.find(
    (x) => x.eaOutcomeId === eaOutcomeId
  );
  if (outcomeObjToCheck)
    return outcomeObjToCheck.outcomeType?.toLowerCase() !== "dwa";
  else return true;
};
const hideConfirmationPopup = (dispatch) => {
  dispatch({
    type: TOGGLE_CONFIRMATION_POPUP,
    data: {
      visible: false,
    },
  });
};
const existingLDDTaskWarning = "";
const showExistingLDDTaskUpdateWarning = (
  dispatch,
  allRoundCaseData,
  previousRoundCase,
  roundCaseWhereTasksAreUpdated,
  tasksToUdpate,
  newDeterminationDate,
  oldDeterminationDate,
  caseRoundDataAccordionInstance
) => {
  dispatch({
    type: TOGGLE_CONFIRMATION_POPUP,
    data: {
      height: "auto",
      autoHeight: true,
      title: "Warning",
      width: 500,
      visible: true,
      confirmShown: true,
      confirmLabel: "OK",
      declineShown: true,
      contentHtml: () => {
        return (
          <>
            {roundCaseWhereTasksAreUpdated?.eaProcessTemplateRoundId > 0 && (
              <div style={{marginTop: 10}}>
                Changing the round determination date will update the round
                submission deadline for the next round.
              </div>
            )}
            {tasksToUdpate?.length > 0 && (
              <div style={{marginTop: 10}}>
                The due date for tasks created based on this case round
                determination date will be updated.
              </div>
            )}
            <div style={{marginTop: 10}}>Do you want to continue?</div>
          </>
        );
      },
      onConfirm: () => {
        hideConfirmationPopup(dispatch);
        dispatch({ type: SHOW_LOADER });
        const updateTaskDueDatesData = tasksToUdpate.map((x) => {
          return {
            dueAfter: x.dueAfterFromTrigger,
            dueInterval: x.dueIntervalFromTrigger,
            userTaskId: x.userTaskId,
          };
        });
        const dataObjectToUpdate = {
          userTaskDueInformationList: updateTaskDueDatesData,
          dueDateToBeCalculatedFromDate: convertDateFormat(
            newDeterminationDate
          ),
          previousEaRoundCaseId: previousRoundCase.eaRoundCaseId,
          currentEaRoundCaseId: roundCaseWhereTasksAreUpdated.eaRoundCaseId,
          currentEaProcessTemplateRoundId: roundCaseWhereTasksAreUpdated.eaProcessTemplateRoundId,
        }
        callOperation(UPDATE_EXISTING_TASKS_DUE_DATE, dataObjectToUpdate)
          .then((response) => {
            dispatch({ type: HIDE_LOADER });
            const tempAllRoundCaseData = cloneDeep(caseRoundDataAccordionInstance.option('dataSource'));
            const currentRoundData = tempAllRoundCaseData.find(
              (x) => x.sequenceNo === previousRoundCase.sequenceNo + 1
            );
            const previousRoundData = tempAllRoundCaseData.find(
              (x) => x.sequenceNo === previousRoundCase.sequenceNo
            );
            if (previousRoundData)
              previousRoundData.roundDeterminationDate = convertDateFormat(
                newDeterminationDate
              );
            if (
              currentRoundData &&
              response?.updatesFromDeterminationDate
                .currentRoundSubmissionDeadlineDate
            ) {
              currentRoundData.roundSubmissionDeadline = convertDateFormat(
                response?.updatesFromDeterminationDate
                  .currentRoundSubmissionDeadlineDate
              );
            }
            if (
              response?.updatesFromDeterminationDate?.userTaskDueInformationList
                ?.length > 0
            ) {
              if (currentRoundData) {
                response?.updatesFromDeterminationDate?.userTaskDueInformationList?.forEach(
                  (updatedTaskData) => {
                    const task = currentRoundData.roundTask.find(
                      (x) => x.userTaskId === updatedTaskData.userTaskId
                    );
                    if (task) task.dueDate = updatedTaskData.dueDate;
                  }
                );
              }
            }
            dispatch({
              type: SET_CASE_FORM_DATA,
              data: {
                caseData: {
                  roundData: [...tempAllRoundCaseData],
                },
              },
            });
          })
          .catch(() => {
            dispatch({ type: HIDE_LOADER });
          });
      },
      onDecline: () => {
        dispatch({
          type: UPDATE_ROUND_DATA,
          data: {
            roundId: previousRoundCase.eaRoundId,
            value: oldDeterminationDate,
            propName: "roundDeterminationDate",
          },
        });
        hideConfirmationPopup(dispatch);
      },
    },
  });
};

//allRoundCaseData - all round cases associated with current EACase
//activeRoundCaseData - A roundCase with max round sequenceNo
//currentRoundCaseData - Current roundCase ui item to render
const roundCaseAccordionItemRender = (
  dispatch,
  allRoundCaseData,
  currentRoundCaseData,
  activeRoundCaseData,
  hasEditAccess,
  caseRoundOutcomeList,
  caseDataValidationMode,
  setCaseRoundOutcomeSelectBoxInstance,
  caseRoundDataAccordionInstance,
  selectedRoundDataTabIndex,
  handleSelectedIndexChange,
  isRoundLineLevelEnabledFlag
) => {
  const roundCaseLevelRequiredValidation = (e) => {
    if (caseDataValidationMode === caseDataValidationModes.ROUND_CASE_LEVEL)
      return e.value != undefined;
    else return true;
  };
  const denialData = currentRoundCaseData?.roundCharges.filter(
    (item) => item.outcomeType === OutcomeTypes.DeniedWillAppeal
  );
  const roundOutcomeDatasource =
    denialData.length > 0
      ? caseRoundOutcomeList?.filter(
          (item) => item.outcomeType === OutcomeTypes.DeniedWillAppeal
        )
      : caseRoundOutcomeList;
  return (
    <div>
      <div className="round-data-flex-item round-data">
        <div className={"round-data-left-fields"}>
          <div className="round-data-flex-item">
            <div className={"round-fields-date"}>
              {/* Round Start Date */}
              <MdaeDateBox
                id={"dtCaseLevelRoundStartDate" + currentRoundCaseData.eaRoundId}
                mdaeDateBoxTitle="Round Start Date"
                defaultValue={currentRoundCaseData.roundStartDate}
                onValueChanged={(e) => {
                  dispatch({
                    type: UPDATE_ROUND_DATA,
                    data: {
                      roundId: currentRoundCaseData.eaRoundId,
                      value: e.value && convertDateFormat(e.value),
                      propName: "roundStartDate",
                    },
                  });
                }}
                readOnly={
                  currentRoundCaseData.sequenceNo !== activeRoundCaseData?.sequenceNo ||
              !hasEditAccess
                }
                type="date"
              >
                <Validator
                  validationGroup={caseDataValidationGroup}
                  name="caseRoundStartDateValidator"
                >
                  <RequiredRule message={"Round Start Date is Required"} />
                </Validator>
              </MdaeDateBox>
            </div>
            <div className={"round-fields-date"}>
              {/* Actual Submission Date */}
              <MdaeDateBox
                id={"dtActualSubmissionDate" + currentRoundCaseData.eaRoundId}
                mdaeDateBoxTitle="Actual Submission Date"
                type="date"
                readOnly={!hasEditAccess}
                defaultValue={currentRoundCaseData.actualSubmissionDate}
                onValueChanged={(e) => {
                  dispatch({
                    type: UPDATE_ROUND_DATA,
                    data: {
                      roundId: currentRoundCaseData.eaRoundId,
                      value: e.value && convertDateFormat(e.value),
                      propName: "actualSubmissionDate",
                    },
                  });
                }}
              >
                <Validator validationGroup={caseDataValidationGroup}>
                  <CustomRule
                    message="Actual Submission Date is Required"
                    validationCallback={roundCaseLevelRequiredValidation}
                  />
                </Validator>
              </MdaeDateBox>
            </div>
            <div className={"round-fields-non-date"}>
              {/* Round Case ID */}
              <MdaeTextBox
                id={"txtAlternateRoundCaseId" + currentRoundCaseData.eaRoundId}
                mdaeTextBoxTitle="Round Case ID"
                defaultValue={currentRoundCaseData.altEaRoundCaseId}
                maxLength={50}
                onValueChanged={(e) => {
                  dispatch({
                    type: UPDATE_ROUND_DATA,
                    data: {
                      roundId: currentRoundCaseData.eaRoundId,
                      value: e.value,
                      propName: "altEaRoundCaseId",
                    },
                  });
                }}
                readOnly={
                  currentRoundCaseData.sequenceNo != activeRoundCaseData?.sequenceNo ||
              !hasEditAccess
                }
              ></MdaeTextBox>
            </div>
          </div>
          <div className="round-data-flex-item top-margin">
            <div className={"round-fields-date"}>
              {/* Round Submission Deadline */}
              <MdaeDateBox
                id={"dtRoundSubmissionDeadline" + currentRoundCaseData.eaRoundId}
                mdaeDateBoxTitle="Round Submission Deadline"
                defaultValue={currentRoundCaseData.roundSubmissionDeadline}
                onValueChanged={(e) => {
                  dispatch({
                    type: UPDATE_ROUND_DATA,
                    data: {
                      roundId: currentRoundCaseData.eaRoundId,
                      value: e.value && convertDateFormat(e.value),
                      propName: "roundSubmissionDeadline",
                    },
                  });
                }}
                readOnly={
                  currentRoundCaseData.sequenceNo !=
                    activeRoundCaseData?.sequenceNo || !hasEditAccess
                }
                type="date"
              ></MdaeDateBox>
            </div>
            <div className={"round-fields-date"}>
              {/* Round Determination Date */}
              <MdaeDateBox
                id={"dtRoundDeterminationDate" + currentRoundCaseData.eaRoundId}
                mdaeDateBoxTitle="Round Determination Date"
                defaultValue={currentRoundCaseData.roundDeterminationDate}
                type="date"
                readOnly={
                  !hasEditAccess ||
                  currentRoundCaseData.sequenceNo <
                    activeRoundCaseData?.sequenceNo - 1
                }
                onValueChanged={(e) => {
                  const newDeterminationDate = convertDateFormat(e.value);
                  const oldDeterminationDate = convertDateFormat(
                    e.previousValue
                  );
                  //if for active round
                  if (
                    currentRoundCaseData.sequenceNo !==
                    activeRoundCaseData?.sequenceNo
                  ) {
                    //else for past rounds
                    const previousRoundCase = allRoundCaseData.find(
                      (x) => x.sequenceNo === currentRoundCaseData.sequenceNo
                    );
                    const roundCaseWhereTasksAreUpdated = allRoundCaseData.find(
                      (x) =>
                        x.sequenceNo === currentRoundCaseData.sequenceNo + 1
                    );
                    const tasksWithLDDTriggerFromNextRound = roundCaseWhereTasksAreUpdated?.roundTask.filter(
                      (x) => x.triggerType?.toLowerCase() === "ldd"
                    );
                    //if there are no LDD triggers
                    if (tasksWithLDDTriggerFromNextRound?.length > 0 || roundCaseWhereTasksAreUpdated.eaProcessTemplateRoundId) {
                      //there are LDD triggers
                      showExistingLDDTaskUpdateWarning(
                        dispatch,
                        allRoundCaseData,
                        previousRoundCase,
                        roundCaseWhereTasksAreUpdated,
                        tasksWithLDDTriggerFromNextRound,
                        newDeterminationDate,
                        oldDeterminationDate,
                        caseRoundDataAccordionInstance
                      );
                    }
                  }
                  dispatch({
                    type: UPDATE_ROUND_DATA,
                    data: {
                      roundId: currentRoundCaseData.eaRoundId,
                      value: newDeterminationDate,
                      propName: "roundDeterminationDate",
                    },
                  });
                }}
              >
                <Validator validationGroup={caseDataValidationGroup}>
                  <CustomRule
                    message="Round Determination Date is Required"
                    validationCallback={roundCaseLevelRequiredValidation}
                  />
                </Validator>
              </MdaeDateBox>
            </div>
            <div className={"round-fields-non-date"}>
              {/* Round Outcome */}
              <MdaeSelectBox
                id={"ddlRoundOutcome" + currentRoundCaseData.eaRoundId}
                mdaeDropDownBoxTitle={"Round Outcome"}
                displayExpr={"eaOutcomeName"}
                valueExpr={"eaOutcomeId"}
                readOnly={
                  currentRoundCaseData.sequenceNo != activeRoundCaseData?.sequenceNo ||
              !hasEditAccess
                }
                onInitialized={(e) => {
                  if (currentRoundCaseData.sequenceNo === activeRoundCaseData?.sequenceNo)
                    setCaseRoundOutcomeSelectBoxInstance(e.component);
                }}
                dataSource={roundOutcomeDatasource || []}
                defaultValue={currentRoundCaseData.roundOutcomeId}
                itemRender={(e) => {
                  if (e.activeInd !== false) {
                    return <div>{e.eaOutcomeName}</div>;
                  }
                }}
                onItemClick={(e) => {
                  setTimeout(() => {
                    let tempCaseData: any = {
                      currentRoundOutcomeName: e.component.option(
                        "selectedItem"
                      )?.eaOutcomeName,
                    };
                    if (e.itemData?.outcomeType?.toLowerCase() === "dwa") {
                      tempCaseData.caseFinalOutcomeId = null;
                    }
                    dispatch({
                      type: SET_CASE_FORM_DATA,
                      data: {
                        caseData: {
                          caseFinalOutcomeId: tempCaseData.caseFinalOutcomeId,
                        },
                      },
                    });
                  }, 100);
                }}
                onValueChanged={(e) => {
                  dispatch({
                    type: UPDATE_ROUND_DATA,
                    data: {
                      roundId: currentRoundCaseData.eaRoundId,
                      value: e.value,
                      propName: "roundOutcomeId",
                    },
                  });
                  dispatch({
                    type: UPDATE_ROUND_DATA,
                    data: {
                      roundId: currentRoundCaseData.eaRoundId,
                      value: e.component.option("selectedItem")?.outcomeType,
                      propName: "roundOutcomeType",
                    },
                  });
                  if (e.component.option("selectedItem")?.activeInd !== false)
                    dispatch({
                      type: UPDATE_ROUND_DATA,
                      data: {
                        roundId: currentRoundCaseData.eaRoundId,
                        value: false,
                        propName: "isRoundOutcomeTermed",
                      },
                    });
                  dispatch({
                    type: UPDATE_ROUND_DATA,
                    data: {
                      roundId: currentRoundCaseData.eaRoundId,
                      value: true,
                      propName: "isRoundOutcomeChangedByUser",
                    },
                  });
                  if (!e.value)
                    dispatch({
                      type: SET_CASE_FORM_DATA,
                      data: {
                        caseData: {
                          caseFinalOutcomeId: null,
                        },
                      },
                    });
                }}
              >
                <Validator validationGroup={caseDataValidationGroup}>
                  <CustomRule
                    message="Round Outcome is Required"
                    validationCallback={roundCaseLevelRequiredValidation}
                  />
                </Validator>
              </MdaeSelectBox>
            </div>
          </div>
        </div>
        <div style={{ flex: 1 }}>
          <MdaeTextArea
            id={"txtRoundNotes" + currentRoundCaseData.eaRoundId}
            mdaeTextAreaTitle={`Round ${currentRoundCaseData?.sequenceNo} Notes`}
            readOnly={!hasEditAccess}
            maxLength={1000}
            height={115}
            defaultValue={currentRoundCaseData.roundNotes}
            onValueChanged={(e) => {
              dispatch({
                type: UPDATE_ROUND_DATA,
                data: {
                  roundId: currentRoundCaseData.eaRoundId,
                  value: e.value,
                  propName: "roundNotes",
                },
              });
            }}
          ></MdaeTextArea>
        </div>
      </div>
      <div>
        <MdaeTabPanel
          id={"tbPanel" + currentRoundCaseData.eaRoundId}
          selectedIndex={
            selectedRoundDataTabIndex?.[currentRoundCaseData.eaRoundId] || 0
          }
          onSelectedIndexChange={(tabIndex) =>
            handleSelectedIndexChange(currentRoundCaseData.eaRoundId, tabIndex)
          }
        >
          {isRoundLineLevelEnabledFlag && (
            <Item title={"Charges"}>
              <RoundLineLevelTrackingComponent
                currentEaRoundCaseId={currentRoundCaseData?.eaRoundCaseId}
              />
            </Item>
          )}
          <Item title={"Tasks"}>
            <TaskAssociatedWithCaseDataGrid
              currentEaRoundCaseId={currentRoundCaseData?.eaRoundCaseId}
            />
          </Item>
        </MdaeTabPanel>
      </div>
    </div>
  );
};

const getTaskAssociatedCaseDataGridOptions = (
  dispatch,
  dataSource: any[],
  currentUser,
  caseData,
  currentEaRoundCaseId: number
) => {
  const taskAssociatedCaseDataConfig: IMdaeDataGridProps = {
    id: "grdTaskAssociatedCase",
    dataSource: dataSource,
    allowColumnResizing: true,
    allowColumnReordering: true,
    columnAutoWidth: true,
    columnMinWidth: 100,
    headerFilter: {
      visible: true,
    },
    mdaeColumns: [
      {
        dataField: "userTaskId",
        visible: false,
      },
      {
        dataField: "completeInd",
        caption: "Complete",
        allowFiltering: true,
        allowSorting: true,
        fixed: true,
        allowHiding: false,
        visible: true,
        cellRender: (cellData) => {
          let completedInd = cellData.displayValue;
          if (cellData.data.assignedToUserId == currentUser?.userId) {
            return (
              <MdaeCheckBox
                id=""
                defaultValue={completedInd}
                onValueChanged={function (e) {
                  if (!cellData.data.completeInd) {
                    dispatch({ type: SHOW_LOADER });
                    const currentRowData = cellData.data;
                    const task = {
                      completionDate: new Date(),
                      userTaskId: currentRowData.userTaskId,
                      refTaskId: currentRowData.refTaskId,
                      attachedLevelId: currentRowData.attachedLevelId,
                      attachedLevel: currentRowData.attachedLevel,
                      auditId: currentRowData.auditId,
                      assignedToUserId: currentRowData.assignedToUserId,
                      assignedToUserName: currentRowData.assignedToUserName
                    };
                    callOperation(QUICK_COMPLETE_USER_TASK, task).then(function (
                      response
                    ) {
                      dispatch({ type: HIDE_LOADER });
                      if (response.isUpdated) {
                        const currentRoundData = caseData.roundData.filter(
                          (x) => x.eaRoundCaseId === currentEaRoundCaseId
                        );

                        currentRoundData[0].roundTask = currentRoundData[0].roundTask?.filter(
                          (x) => x.userTaskId !== currentRowData.userTaskId
                        );

                        dispatch({
                          type: SET_CASE_FORM_DATA,
                          data: {
                            caseData: {
                              ...caseData,
                              uniqueId: new Guid().toString(),
                            },
                          },
                        });

                        mdaeNotify({
                          message:
                            currentRowData.refTaskName +
                            " - task updated successfully.",
                          messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
                        });
                      }
                      if (
                        response.newUserTasksCreated &&
                        response.newUserTasksCreated.length > 0
                      ) {
                        var displayMessage = "";
                        var arrayOfTaskItem = [];
                        for (var item of response.newUserTasksCreated) {
                          displayMessage =
                            " " +
                            item.refTaskName +
                            ", " +
                            "Assigned To: " +
                            item.assignedToUserName +
                            ", Due " +
                            new Date(item.dueDate)?.toLocaleDateString();
                          arrayOfTaskItem.push(displayMessage);
                        }
                        dispatch({
                          type: TOGGLE_NOTIFY_POPUP,
                          data: {
                            visible: true,
                            contentHtml: () => {
                              return (
                                <div>
                                  <div style={{ display: "block" }}>
                                    New task(s) were created as a result of
                                    updating this task and have been configured
                                    based on the process template.{" "}
                                  </div>
                                  <div>
                                    <ul>{getTaskItem(arrayOfTaskItem)}</ul>
                                  </div>
                                </div>
                              );
                            },
                            notifyPopupType: NOTIFY_POPUP_TYPES.ALERT,
                            closeButtonText: "OK",
                            width: 470,
                            height: "auto",
                          },
                        });
                      }
                    });
                  }
                  e.component.option("value", true);
                }}
              />
            );
          }
        },
      },
      {
        dataField: "refTaskName",
        caption: "Task",
        minWidth: 150,
        allowFiltering: true,
        allowSorting: true,
        fixed: true,
      },

      {
        dataField: "levelName",
        caption: "Level Name",
        allowFiltering: true,
        allowSorting: true,
      },
      {
        dataField: "status",
        caption: "Status",
        allowFiltering: true,
        allowSorting: true,
      },

      {
        dataField: "assignedToUserName",
        caption: "Assigned To",
        minWidth: 140,
        allowFiltering: true,
        allowSorting: true,
      },

      {
        dataField: "dueDate",
        caption: "Due Date",
        dataType: "date",
        format: "MM/dd/yyyy",
        allowFiltering: true,
        allowSorting: true,
        sortOrder: "asc",
      },
      {
        dataField: "scheduledDate",
        caption: "Rescheduled Date",
        dataType: "date",
        format: "MM/dd/yyyy",
        allowFiltering: true,
        allowSorting: true,
      },
      {
        dataField: "statusType",
        caption: "Status Type",
        allowFiltering: true,
        allowSorting: true,
        sortOrder: "desc",
        visible: false,
      },
      {
        dataField: "assignedToUserId",
        caption: "Assigned To UserId",
        allowFiltering: true,
        allowSorting: true,
        visible: false,
        showInColumnChooser: false,
      },
      {
        dataField: "attachedLevelDisplayName",
        caption: "Level",
        minWidth: 120,
        allowFiltering: true,
        allowSorting: true,
        visible: true,
      },
      {
        dataField: "requiredForAuditCompletionInd",
        caption: "Required",
        allowFiltering: true,
        allowSorting: false,
        allowEditing: false,
        allowGrouping: false,
        visible: false,
        dataType: "boolean",
        falseText: "No",
        trueText: "Yes",
      },
      {
        dataField: "completionDate",
        caption: "Completed Date",
        dataType: "date",
        format: "MM/dd/yyyy",
        allowFiltering: true,
        allowSorting: true,
      },
      {
        dataField: "completedBy",
        caption: "Completed By",
        minWidth: 140,
        allowFiltering: true,
        allowSorting: true,
      },
      {
        dataField: "taskCategoryName",
        caption: "Category",
        minWidth: 130,
        allowFiltering: true,
        allowSorting: true,
      },
      {
        dataField: "taskCategoryType",
        caption: "Category Type",
        allowFiltering: true,
        allowSorting: true,
        visible: false,
      },
      {
        dataField: "requiredTaskNote",
        caption: "Last Note",
        visible: false,
      },
      {
        dataField: "auditTitle",
        caption: "Audit",
        visible: false,
      },
      {
        dataField: "entityTitle",
        caption: "Entity",
        visible: false,
      },
      {
        dataField: "updatedBy",
        caption: "Updated by",
        allowFiltering: true,
        allowSorting: true,
      },
      {
        dataField: "updateDate",
        caption: "Updated on",
        dataType: "date",
        format: "MM/dd/yyyy",
        allowFiltering: true,
        allowSorting: true,
      },
      {
        dataField: "attachedDocumentCount",
        caption: "Documents",
        allowFiltering: true,
        allowSorting: true,
        visible: false,
      },
      {
        dataField: "roundNo",
        caption: "Round",
        dataType: "number",
        visible: false,
        allowFiltering: true,
        allowSorting: true,
      },
    ],
  };
  return taskAssociatedCaseDataConfig;
};

export default CaseData;
